import {request, setAuthInHeader} from "@/api/request";
import {isDev} from "@/api/config";
import util from "@/mixins/util";
// import {req} from "vuelidate/src/validators/common";


let $api = {
    $auth: {
        // 계정 로그인
        login(params) {
            return request.javaPost("v1/admin/login", params).then(({data}) => data);
        },
        logout(params) {
            return request.javaDelete("v1/admin/logout", params).then(({data}) => data);
        },
        checkPermission(params) {
            return request.javaGet("v1/admin/authority/CMS/check", params).then(({data}) => data);
        },
    },
    $member: {
        sendPhoneCertification(params) {
            //인증번호 발송
            return request
                .javaPost("v1/auth/send", params)
                .then(({data}) => data);
        },
        checkLoginPhone(params) {
            //로그인 인증번호 확인
            return request.javaPost("v1/auth/verify", params).then(({data}) => data);
        },
        getPartnerDetail(params) {
            let mpIdx = params.mpIdx;
            delete params.mpIdx;
            let mpType = params.mpType;
            delete params.mpType;
            return request.javaGet(`v1/admin/neighbor-partner/${mpIdx}/${mpType}`, params).then(({data}) => data);
        },
        getPartnerOutDetail(params) {
            let mbNo = params.mbNo;
            delete params.mbNo;
            let mpType = params.mpType;
            delete params.mpType;
            return request.javaGet(`v1/admin/neighbor-partner/out/${mbNo}/${mpType}`, params).then(({data}) => data);
        },

        getQuitPartner(params) {
            return request.javaGet("v1/admin/member-partner/quit", params).then(({data}) => data);
        },
        getSleepMediaPartner(params) {
            return request.javaGet("v1/admin/neighbor-partner/media/sleep/list", params).then(({data}) => data);
        },
        getSleepAdPartner(params) {
            return request.javaGet("v1/admin/neighbor-partner/advertisement/sleep/list", params).then(({data}) => data);
        },
        getSleepShoppingPartner(params) {
            return request.javaGet("v1/admin/neighbor-partner/shopping/sleep/list", params).then(({data}) => data);
        },
        getTerminatePartner(params) {
            return request.javaGet("v1/admin/member-partner/terminate", params).then(({data}) => data);
        },
        getPartnerMedia(params) {
            return request.javaGet('v1/admin/neighbor-partner/media/list', params).then(({data}) => data);
        },
        getPartnerAd(params) {
            return request.javaGet('v1/admin/neighbor-partner/advertisement/list', params).then(({data}) => data);
        },
        getPartnerShopping(params) {
            return request.javaGet('v1/admin/neighbor-partner/shopping/list', params).then(({data}) => data);
        },
        updatePartner(params) {
            let mpIdx = params.mpIdx;
            delete params.mpIdx;
            let mpType = params.mpType;
            delete params.mpType;
            return request.javaPut(`v1/admin/member-partner/${mpType}/${mpIdx}`, params).then(({data}) => data);
        },
        getSuspension(params) {
            return request.javaGet("v1/admin/member/suspension/detail", params).then(({data}) => data);
        },
        changeMemberStatus(params) {
            return request.javaPut("v1/admin/member/status", params).then(({data}) => data);
        },
        deleteMember(params) {
            return request.javaDelete("v1/admin/member/delete", params).then(({data}) => data);
        },
        memberParterStatusChange(params) {
            let id = params.id;
            let status = params.status;
            delete params.id;
            delete params.status;
            return request.javaPatch(`v1/admin/member-partner/${id}/${status}`, params).then(({data}) => data);
        },
        getDeleteCategory(params) {
            return request.javaGet("v1/admin/member/out/category", params).then(({data}) => data);
        },
        getMarketing(params) {
            return request.javaGet("v1/admin/marketing/partner", params).then(({data}) => data);
        },
        getOrderShoppingReady(params) {
            return request.javaGet('v1/admin/order/shopping/ready', params).then(({data}) => data);
        },
        //반품 요청
        getOrderRefundRequest(params) {
            return request.javaGet('v1/admin/order/refund/request', params).then(({data}) => data);
        },
        getOrderMember(params) {
            return request.javaGet('v1/admin/order', params).then(({data}) => data);
        },
        updateAdmin(params) {
            return request.javaPut("v1/admin/member", params).then(({data}) => data);
        },
        updateSuperAdmin(params) {
            // 최고 관리자
            return request.javaPut("v1/admin/member", params).then(({data}) => data);
        },
        createDownloadHistory(params) {
            return request.javaPost("v1/admin/download/history", params).then(({data}) => data);
        },
        checkIdDuplicate(params) {
            //아이디 중복 확인
            let mbId = params.mbId;
            delete params.mbId;
            return request.javaGet(`v1/admin/chk/id/${mbId}`, params).then(({data}) => data);
        },
        updateMemberPwd(params) {
            return request.javaPatch("v1/admin/password", params).then(({data}) => data);
        },
        chkPassword(params) {
            return request.javaPost("v1/admin/chk/password", params).then(({data}) => data);
        },
        findId(params) {
            let mbNo = params.mbNo;
            delete params.mbNo;
            return request.javaPost(`v1/admin/send/id/${mbNo}`, params).then(({data}) => data);
        },
        getRegisterPath(params) {
            return request.javaGet("v1/admin/admin/member-partner/registerPath", params).then(({data}) => data);
        },
        getActiveMember(params) {
            return request.javaGet("v1/admin/members/active", params).then(({data}) => data);
        },
    },
    $soInfo: {
        getSoInfo(params) {
            return request.javaGet("v1/so", params).then(({data}) => data);
        },
    },
    $profile: {
        getProfile(params) {
            return request.javaGet("v1/admin/profile", params).then(({data}) => data);
        },
        getProfileDetail(params) {
            let id = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/profile/detail/${id}`, params).then(({data}) => data);
        },
        createProfile(params) {
            return request.javaPost("v1/admin/profile", params).then(({data}) => data);
        },
        updateProfile(params) {
            let id = params.id;
            delete params.id;
            return request.javaPut(`v1/admin/profile/${id}`, params).then(({data}) => data);
        },
        deleteProfile(params) {
            let id = params.id;
            delete params.id;
            return request.javaDelete(`v1/admin/profile/${id}`, params).then(({data}) => data);
        },
    },
    $admin: {
        getAuthorityActive(params) {
            let id = params.mbNo;
            delete params.mbNo;
            return request.javaGet(`v1/admin/authority/CMS/${id}/active`, params).then(({data}) => data);
        },
        getAuthFormatAdmin(params) {
            return request.javaGet("v1/admin/authority/format/CMS", params).then(({data}) => data);
        },
        getAuthFormatAdminDetail(params) {
            let id = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/authority/format/CMS/${id}`, params).then(({data}) => data);
        },
        changeMemberStatus(params) {
            // 회원 상태 수정
            return request
                .javaPut("v1/admin/member/status", params)
                .then(({data}) => data);
        },
        sendPwd(params) {
            let mbNo = params.mbNo;
            delete params.mbNo;
            return request.javaPost(`v1/admin/send/pw/${mbNo}`, params).then(({data}) => data);
        },
        getSuperAdmin(params) {
            return request.javaGet("v1/admin/members/super", params).then(({data}) => data);
        },
        getLongTermAdmin(params) {
            return request.javaGet("v1/admin/members/dormant", params).then(({data}) => data);
        },
        getQuitAdmin(params) {
            return request.javaGet("v1/admin/members/quit", params).then(({data}) => data);
        },
        getAdmin(params) {
            return request.javaGet("v1/admin/members/normal", params).then(({data}) => data);
        },
        createAdmin(params) {
            return request.javaPost("v1/admin/member", params).then(({data}) => data);
        },
        updateAdmin(params) {
            return request.javaPut("v1/admin/member", params).then(({data}) => data);
        },
        deleteAdmin(params) {
            let mbNo = params.mbNo;
            delete params.mbNo;
            return request
                .javaDelete(`v1/admin/member/${mbNo}`, params)
                .then(({data}) => data);
        },
        deleteAdminAll(params) {
            return request
                .javaDelete(`v1/admin/members`, params)
                .then(({data}) => data);
        },
        getAdminDetail(params) {
            let key = params.mbNo;
            delete params.mbNo;
            return request.javaGet(`v1/admin/member/admin/normal/detail/${key}`, params).then(({data}) => data);
        },
        getAdminAll(params) {
            return request.javaGet("v1/admin/members/All", params).then(({data}) => data);
        },
        updateAdminAuth(params) {
            let key = params.mbNo;
            delete params.mbNo;
            return request.javaPut(`v1/super/admin/authority/CMS/${key}`, params).then(({data}) => data);
        },
        getAuthFormat(params) {
            return request.javaGet("v1/admin/authority/format/CRM", params).then(({data}) => data);
        },

        getAuthFormatDetail(params) {
            let key = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/authority/format/CMS/${key}`, params).then(({data}) => data);
        },
        updateStatus(params) {
            return request.javaPut('v1/admin/member/status', params).then(({data}) => data);
        },
        createAdminAuthority(params) {
            return request.javaPost('v1/admin/authority/format/CMS', params).then(({data}) => data);
        },
        updateAdminAuthority(params) {
            return request.javaPut('v1/super/admin/authority/format/CMS', params).then(({data}) => data);
        },
        getSo(params) {
            return request.javaGet("v1/so", params).then(({data}) => data);
        },
        getTeam(params) {
            return request.javaGet("v1/admin/ip/define", params).then(({data}) => data);
        },

    },
    $config: {
        getGroup(params) {
            return request.javaGet(`v1/group`, params).then(({data}) => data);
        },
        getConfig(params) {
            return request.javaGet("v1/admin/config", params).then(({data}) => data);
        },
        getSo(params) {
            return request.javaGet('v1/so', params).then(({data}) => data);
        },
    },
    $board: {
        getAlarm(params) {
            return request.javaGet("v1/admin/alarm/history", params).then(({data}) => data);
        },
        createAlarm(params) {
            return request.javaPost("v1/admin/alarm/history", params).then(({data}) => data);
        },
        getAlarmDetail(params) {
            let key = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/alarm/history/${key}`, params).then(({data}) => data);
        },
        getConfigCategory(params) {
            return request.javaGet(`v2/admin/CMS/config/category`, params).then(({data}) => data);
        },
        getConfig(params) {
            return request.javaGet("v1/admin/config", params).then(({data}) => data);
        },
        getConfigDetail(params) {
            let coIdx = params.coIdx;
            delete params.coIdx;
            return request.javaGet(`v1/admin/CMS/config/${coIdx}`, params).then(({data}) => data);
        },
        createConfig(params) {
            return request.javaPost(`v1/admin/CMS/config`, params).then(({data}) => data);
        },
        deleteConfig(params) {
            let coIdx = params.coIdx;
            delete params.coIdx;
            return request.javaDelete(`v1/admin/CMS/config/${coIdx}`, params).then(({data}) => data);
        },
        getNotice(params) {
            return request.javaGet('v1/admin/notice', params).then(({data}) => data);
        },
        getNoticeDetail(params) {
            let id = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/notice/${id}`, params).then(({data}) => data);
        },
        createNotice(params) {
            return request.javaPost("v1/admin/notice", params).then(({data}) => data);
        },
        updateNotice(params) {
            let id = params.id;
            delete params.id;
            return request.javaPut(`v1/admin/notice/${id}`, params).then(({data}) => data);
        },
        deleteNotice(params) {
            return request.javaDelete(`v1/admin/notice`, params).then(({data}) => data);
        },
        deleteNoticeOne(params) {
            let id = params.id;
            delete params.id;
            return request.javaDelete(`v1/admin/notice/${id}`, params).then(({data}) => data);
        },
        getFaq(params) {
            return request.javaGet("v1/admin/faq", params).then(({data}) => data);
        },
        getFaqDetail(params) {
            let faIdx = params.faIdx;
            delete params.faIdx;
            return request.javaGet(`v1/admin/faq/${faIdx}`, params).then(({data}) => data);
        },
        getFaqCategory(params) {
            return request.javaGet("v1/admin/faq/category", params).then(({data}) => data);
        },
        createFaq(params) {
            return request.javaPost("v1/admin/faq", params).then(({data}) => data);
        },
        createFaqCategory(params) {
            return request.javaPost("v1/admin/faq/category", params).then(({data}) => data);
        },
        updateFaqCategory(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx;
            return request.javaPut(`v1/admin/faq/category/${fcIdx}`, params).then(({data}) => data);
        },
        updateFaq(params) {
            let faIdx = params.faIdx;
            delete params.faIdx;
            return request.javaPut(`v1/admin/faq/${faIdx}`, params).then(({data}) => data);
        },
        deleteFaqCategory(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx;
            return request.javaDelete(`v1/admin/faq/category/${fcIdx}`, params).then(({data}) => data);
        },
        deleteFaq(params) {
            let faIdx = params.faIdx;
            delete params.faIdx;
            return request.javaDelete(`v1/admin/faq/${faIdx}`, params).then(({data}) => data);
        },
        deleteMultiFaq(params) {
            return request.javaDelete("v1/admin/faq", params).then(({data}) => data);
        },
        getQna(params) {
            return request.javaGet("v1/admin/qna", params).then(({data}) => data);
        },
        getQnaDetail(params) {
            let id = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/qna/${id}`, params).then(({data}) => data);
        },
        commentQna(params) {
            return request.javaPost(`v1/admin/qna/answer`, params).then(({data}) => data);
        },
        updateCommentQna(params) {
            let id = params.id;
            delete params.id;
            return request.javaPut(`v1/admin/qna/answer/${id}`, params).then(({data}) => data);
        },
        deleteComment(params) {
            let id = params.id;
            delete params.id;
            return request.javaDelete(`v1/admin/qna/answer/${id}`, params).then(({data}) => data);
        },
        deleteQna(params) {
            let id = params.id;
            delete params.id;
            return request.javaDelete(`v1/admin/qna/question/${id}`, params).then(({data}) => data);
        },
        getIp(params) {
            return request.javaGet(`v1/admin/allow/ip`, params).then(({data}) => data);
        },
        createIp(params) {
            return request.javaPost("v1/admin/allow/ip", params).then(({data}) => data);
        },
        deleteIp(params) {
            let id = params.id;
            delete params.id;
            return request.javaDelete(`v1/admin/allow/ip/${id}`, params).then(({data}) => data);
        },
        getWebMain(params) {
            return request.javaGet(`v1/admin/webMain`, params).then(({data}) => data);
        },
        getReport(params) {
            return request.javaGet(`v1/admin/reports`, params).then(({data}) => data);
        },
        getReportDetail(params) {
            let id = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/report/${id}`, params).then(({data}) => data);
        },
        getReportCategory(params) {
            return request.javaGet(`v1/admin/report/category`, params).then(({data}) => data);
        },
        getReportMedia(params) {
            return request.javaGet(`v1/admin/reports/content`, params).then(({data}) => data);
        },
        getReportMediaDetail(params) {
            let id = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/reports/content/${id}`, params).then(({data}) => data);
        },

    },
    $channel: {

    },
    $advertisement: {
        getAdvertisement(params) {
            return request.javaGet(`v1/admin/advertise`, params).then(({data}) => data);
        },
        getAdvertisementInfo(params) {
            let acIdx = params.acIdx;
            delete params.acIdx;
            return request.javaGet(`v1/admin/advertise/${acIdx}`, params).then(({data}) => data);
        },
        editMetaAdvertisement(params) {
            let acIdx = params.acIdx;
            delete params.acIdx;
            return request.javaPut(`v1/admin/advertise/${acIdx}/metadata`, params).then(({data}) => data);
        },
        editHashTagAdvertisement(params) {
            return request.javaPut(`v1/admin/advertise/hashtag`, params).then(({data}) => data);
        },
        getAdvertisementMetaInfo(params) {
            let acIdx = params.acIdx;
            delete params.acIdx;
            return request.javaGet(`v1/admin/advertise/${acIdx}/metadata`, params).then(({data}) => data);
        },
        getAdvertisementDetail(params) {
            let key = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/advertise/${key}`, params).then(({data}) => data);
        },
        getAdvertisementDelete(params) {
            return request.javaGet(`v1/admin/advertise/delete`, params).then(({data}) => data);
        },
        getAdvertisementArea(params) {
            return request.javaGet("v1/area/si", params).then(({data}) => data);
        },
        getAdvertisementItem(params) {
            return request.javaGet("v1/admin/item/advertise", params).then(({data}) => data);
        },
        createAdvertiseWithoutPaid(params) {
            let acIdx = params.acIdx;
            delete params.acIdx;
            return request.javaPost(`v1/admin/order/withoutpaid/${acIdx}`, params).then(({data}) => data);
        },
        deleteAdvertisement(params) {
            return request.javaDelete("v1/admin/advertise", params).then(({data}) => data);
        },
        confirmAdAdmission(params) {
            return request.javaPut("v1/admin/advertise/admission/apply", params).then(({data}) => data);
        },
        rejectAdAdmission(params) {
            return request.javaPut("v1/admin/advertise/admission/reject", params).then(({data}) => data);
        },
        getAdvFrequency(params) {
            let amType = params.amType;
            delete params.amType;
            return request.javaGet(`v1/admin/advertise/management/${amType}`, params).then(({data}) => data);
        },
        updateAdvFrequency(params) {
            let amIdx = params.amIdx;
            delete params.amIdx;
            return request.javaPut(`v1/admin/advertise/management/frequency/${amIdx}`, params).then(({data}) => data);
        },

        getAdvOrder(params) {
            return request.javaGet("v1/admin/advertise/management/order", params).then(({data}) => data);
        },

        getAdvOrderDetail(params) {
            let amType = params.amType;
            delete params.amType;
            return request.javaGet(`v1/admin/advertise/management/${amType}`, params).then(({data}) => data);
        },

        updateVideoSeq(params) {
            return request.javaPut(`v1/admin/advertise/management/seq`, params).then(({data}) => data);
        },
        createCart(params) {
            return request.javaPost("v1/admin/cart", params).then(({data}) => data);
        },
        createCartOrder(params) {
            return request.javaPost("cart/order", params).then(({data}) => data);
        },
        createOrder(params) {
            return request.javaPost("v1/admin/order", params).then(({data}) => data);
        },

        getAdvertisementPending(params) {
            return request.javaGet(`v1/admin/advertise/pending`, params).then(({data}) => data);
        },
        createInstream(params) {
            return request.javaPost("v1/admin/advertise/instream", params).then(({data}) => data);
        },

        createFast(params) {

            return request.javaPost("v1/admin/advertise/fast", params).then(({data}) => data);
        },
        createBanner(params) {
            return request.javaPost("v1/admin/advertise/banner", params).then(({data}) => data);
        },

        updatePopup(params) {
            return request.javaPut("v1/admin/advertise/instream", params).then(({data}) => data);
        },
        updateInstream(params) {
            return request.javaPut("v1/admin/advertise/instream", params).then(({data}) => data);
        },
        updateFast(params) {
            return request.javaPut("v1/admin/advertise/fast", params).then(({data}) => data);
        },
        updateBanner(params) {
            return request.javaPut("v1/admin/advertise/banner", params).then(({data}) => data);
        },


        getOrderedAdvertisement(params) {
            return request.javaGet("v1/admin/advertise/display-order-detail", params).then(({data}) => data);
        },

        updateAdvertisementOrder(params) {
            let amIdx = params.amIdx;
            delete params.amIdx;
            let amDisplay = params.amDisplay;
            delete params.amDisplay;
            return request.javaPut(`v1/admin/advertise/management/order/${amIdx}/${amDisplay}`, params).then(({data}) => data);
        },

        getAiRecomment(params) {
            return request.javaGet(`v1/admin/advertise/management/ai`, params).then(({data}) => data);
        },
        updateAiRecommend(params) {
            return request.javaPut(`v1/admin/advertise/management/ai`, params).then(({data}) => data);
        },
    },
    $media: {
        getMedia(params) {
            return request.javaGet("v1/admin/media", params).then(({data}) => data);
        },
        getMediaBanner(params) {
            return request.javaGet("v1/admin/media/banner", params).then(({data}) => data);
        },
        getHomeMedia(params) {
            return request.javaGet("v1/admin/media/home", params).then(({data}) => data);
        },
        getMemberUploadMedia(params) {
            let id = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/member-partner/media/${id}`, params).then(({data}) => data);
        },
        getMediaInfo(params) {
            let meIdx = params.meIdx;
            delete params.meIdx
            return request.javaGet(`v1/admin/media/${meIdx}`, params).then(({data}) => data);
        },
        getMediaMetaInfo(params) {
            let meIdx = params.meIdx;
            delete params.meIdx
            return request.javaGet(`v1/admin/media/${meIdx}/metadata`, params).then(({data}) => data);
        },
        getPendingMedia(params) {
            return request.javaGet("v1/admin/media/pending", params).then(({data}) => data);
        },
        getMediaDelete(params) {
            return request.javaGet("v1/admin/media/delete", params).then(({data}) => data);
        },
        getMediaCategory(params) {
            return request.javaGet("v1/admin/media/category/list", params).then(({data}) => data);
        },
        getProvider(params) {
            return request.javaGet("v1/admin/content/provider", params).then(({data}) => data);
        },
        getLocationCategory(params) {
            return request.javaGet("v1/admin/class/area", params).then(({data}) => data);
        },
        getMediaAdmCategory(params) {
            return request.javaGet("v1/admin/media/adm/category", params).then(({data}) => data);
        },
        //TODO getRecommendMediaMenu
        // getMediaAdmCategory(params) {
        //     return request.javaGet("v1/admin/media/adm/category", params).then(({data}) => data);
        // },

        getMediaSeries(params) {
            return request.javaGet("v1/admin/media/series", params).then(({data}) => data);
        },
        getMediaSeriesInfo(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/admin/media/series/${meIdx}`, params).then(({data}) => data);
        },
        getMediaSeriesEpisode(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/admin/media/series/episode/${meIdx}`, params).then(({data}) => data);
        },
        getMediaSeriesDelete(params) {
            return request.javaGet("v1/admin/media/series/delete", params).then(({data}) => data);
        },

        createMedia(params) {
            return request.javaPost("v1/admin/media", params).then(({data}) => data);
        },

        editMetaMedia(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaPut(`v1/admin/media/${meIdx}/metadata`, params).then(({data}) => data);
        },
        getSeriesDetail(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/admin/media/series/${meIdx}`, params).then(({data}) => data);
        },
        acceptMedia(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaPut(`v1/admin/media/approval/${meIdx}`, params).then(({data}) => data);
        },
        rejectMedia(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaPut(`v1/admin/media/reject/${meIdx}`, params).then(({data}) => data);
        },
        createMediaSeries(params) {
            return request.javaPost("v1/admin/media", params).then(({data}) => data);
        },

        updateMedia(params) {
            return request.javaPut("v1/admin/media", params).then(({data}) => data);
        },
        createSeriesMedia(params) { //일괄 등록 기능 추가됨으로 사용 X
            return request.javaPut("v1/admin/media/series/create", params).then(({data}) => data);
        },
        deleteSeriesMediaMulti(params) { //일괄 등록 기능 추가됨으로 사용 X
            return request.javaPut("v1/admin/media/series/delete", params).then(({data}) => data);
        },


        deleteMedia(params) {
            return request.javaDelete("v1/admin/media", params).then(({data}) => data);
        },
        getMediaArea(params) {
            return request.javaGet("v1/area/si", params).then(({data}) => data);
        },
        getMediaReason(params) {
            return request.javaGet("v1/admin/media/delete/reason", params).then(({data}) => data);
        },
        encodeVideo(params) {
            return request.encodeVideo(params).then(({data}) => data);
        },
        getFastMedia(params) {
            return request.javaGet('v1/admin/fast/media', params).then(({data}) => data);
        },
        getFastMediaDetail(params) {
            let key = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/fast/media/${key}`, params).then(({data}) => data);
        },

        getVodPackageDetail(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/admin/package/${meIdx}`, params).then(({data}) => data);
        },


        createFastMedia(params) {
            return request.javaPost('v1/admin/fast', params).then(({data}) => data);
        },
        updateFastMedia(params) {
            return request.javaPut('v1/admin/fast', params).then(({data}) => data);
        },

        createPackage(params) {
            return request.javaPost('v1/admin/package', params).then(({data}) => data);
        },
        updatePackage(params) {
            return request.javaPut('v1/admin/package', params).then(({data}) => data);
        },
        deletePackage(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaDelete( `v1/admin/package/${meIdx}`, params).then(({data}) => data);
        },
        deleteBundlePackage(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaDelete( `v1/admin/bundle-package/${meIdx}`, params).then(({data}) => data);
        },
        deleteFastMedia(params) {
            return request.javaDelete('v1/admin/fast', params).then(({data}) => data);
        },
        getMediaDeleteReason(params) {
            return request.javaGet('v1/admin/media/delete/reason', params).then(({data}) => data);
        },
        getRecommendMenuDetail(params) {
            let crmIdx = params.crmIdx;
            delete params.crmIdx;
            return request.javaGet(`v2/admin/content/recommend/menu/${crmIdx}`, params).then(({data}) => data);
        },





        deleteRecommendMedia(params) {
            return request.javaDelete('v1/admin/content/recommend', params).then(({data}) => data);
        },
        getFastAdvertisement(params) {
            return request.javaGet('v1/admin/advertise/set', params).then(({data}) => data);
        },
        getFastAdvertisementInfo(params) {
            let asIdx = params.asIdx;
            delete params.asIdx;
            return request.javaGet(`v1/admin/advertise/set/${asIdx}`, params).then(({data}) => data);
        },
        createFastAdvertisement(params) {
            return request.javaPost('v1/admin/advertise/set', params).then(({data}) => data);
        },
        updateFastAdvertisement(params) {
            return request.javaPut('v1/admin/advertise/set', params).then(({data}) => data);
        },
        deleteFastAdvertisement(params) {
            return request.javaDelete('v1/admin/advertise/set', params).then(({data}) => data);
        },

        deleteMultiMedia(params) {
            return request.javaDelete("v1/admin/media", params).then(({data}) => data);
        },
        deleteMultiFast(params) {
            return request.javaDelete("v1/admin/fast", params).then(({data}) => data);
        },
        getGenres(params) {
            return request.javaGet(`v1/admin/media/genre`, params).then(({data}) => data);
        },
        getContentSetting(params) {
            return request.javaGet('v1/admin/content/setting', params).then(({data}) => data);
        },
        setContentSetting(params) {
            return request.javaPut("v1/admin/content/setting", params).then(({data}) => data);
        },
        getRecommendAlarm(params) {
            return request.javaGet('v1/admin/alarm/setting', params).then(({data}) => data);//API 변경필요
        },
        setRecommendAlarm(params) {
            return request.javaPut('v1/admin/alarm/setting', params).then(({data}) => data);
        },


        getPickMenu(params) {
            return request.javaGet(`v1/admin/recommend/management`, params).then(({data}) => data);
        },
        updatePickMenu(params) {
            let key = params.id;
            delete params.id;
            return request.javaPut(`v1/admin/recommend/management/${key}`, params).then(({data}) => data);
        },



        getNewConfig(params) {
            return request.javaGet('v1/admin/media/new/config', params).then(({data}) => data);
        },

        updateNewConfig(params) {
            let mncDay = params.mncDay;
            delete params.mncDay;
            return request.javaPatch(`v1/admin/media/new/config/${mncDay}`, params).then(({data}) => data);
        },
        getLgTvContents(params) {
            return request.javaGet('v1/admin/lg-feed-content', params).then(({data}) => data);
        },
        getLgTvAbleContents(params) {
            return request.javaGet('v1/admin/lg-feed-content/pure', params).then(({data}) => data);
        },
        getLgTvSelectionMedia(params) {
            return request.javaGet('v1/admin/media/lg-feed-register', params).then(({data}) => data);
        },
        editLgTvContent(params) {
            return request.javaPost('v1/admin/lg-feed-content/batch', params).then(({data}) => data);
        },
        batchSeriesEpisode(params) {
            return request.javaPut('v1/admin/media/series/batch', params).then(({data}) => data);
        },
        moveVod(params){
            return request.javaPost("v1/admin/media/move/vod", params).then(({data}) => data);
        },
        moveValidator(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/admin/media/move/validator/${meIdx}`, params).then(({data}) => data);
        },
        moveFast(params){
            return request.javaPost("v1/admin/media/move/fast", params).then(({data}) => data);
        },
        choiceSeriesEpisode(params) {
            return request.javaGet('v1/admin/media/series-content', params).then(({data}) => data);
        },

        changeGenre(params) {
            return request.javaPut('v1/admin/media/genre', params).then(({data}) => data);
        },
        getVodPackage(params){
            return request.javaGet('v1/admin/package', params).then(({data}) => data);
        },
        getVodPackageRecommend(params){
            return request.javaGet('v1/admin/package/content-recommend', params).then(({data}) => data);
        },
        getVodBundlePackageRecommend(params){
            return request.javaGet('v1/admin/bundle-package/content-recommend', params).then(({data}) => data);
        },
        getVodPackageMedia(params) {
            return request.javaGet("v1/admin/media/package-available", params).then(({data}) => data);
        },


        getVodBundlePackage(params){
            return request.javaGet('v1/admin/bundle-package', params).then(({data}) => data);
        },

        getVodBundlePackageDetail(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/admin/bundle-package/${meIdx}`, params).then(({data}) => data);
        },
        createBundlePackage(params) {
            return request.javaPost('v1/admin/bundle-package', params).then(({data}) => data);
        },
        updateBundlePackage(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaPut(`v1/admin/bundle-package/${meIdx}`, params).then(({data}) => data);
        },
    },
    $shopping: {
        getShopping(params) {
            return request.javaGet("v1/admin/media/shop/list", params).then(({data}) => data);
        },

        getRecommendShopping(params) {
            return request.javaGet("v1/admin/media/shop/content-recommend", params).then(({data}) => data);
        },

        getShoppingDetail(params) {
            let msIdx = params.msIdx;
            delete params.msIdx;
            return request.javaGet(`v1/admin/media/shop/list/${msIdx}`, params).then(({data}) => data);
        },
        getShoppingDelete(params) {
            return request.javaGet("v1/admin/media/shop/list/delete", params).then(({data}) => data);
        },
        getShoppingAdmCategory(params) {
            return request.javaGet("v1/admin/media/adm/category", params).then(({data}) => data);
        },
        getDepositDetail(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx
            return request.javaGet(`v1/admin/order/shopping/deposit/${ordIdx}`, params).then(({data}) => data);
        },
        getRefundCancelDetail(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx
            return request.javaGet(`v1/admin/order/refund/cancel/${ordIdx}`, params).then(({data}) => data);
        },
        //반품 상세
        getRefundDetail(params) {
            let oreIdx = params.oreIdx;
            delete params.oreIdx
            return request.javaGet(`v1/admin/order/shopping/withdraw/${oreIdx}`, params).then(({data}) => data);
        },
        //입금 관리
        getDeposit(params) {
            return request.javaGet('v1/admin/order/shopping/deposit', params).then(({data}) => data);
        },
        getOrderShoppingReady(params) {
            return request.javaGet('v1/admin/order/shopping/ready', params).then(({data}) => data);
        },
        getOrderRefundRequest(params) {
            return request.javaGet('v1/admin/order/refund/request', params).then(({data}) => data);
        },
        getOrderRefundAccept(params) {
            return request.javaGet('v1/admin/order/refund/accept', params).then(({data}) => data);
        },
        getOrderRefundDeny(params) {
            return request.javaGet('v1/admin/order/refund/deny', params).then(({data}) => data);
        },
        getShoppingOrder(params) {
            return request.javaGet('v1/admin/order/shopping/order', params).then(({data}) => data);
        },
        getShoppingOrderDetail(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaGet(`v1/admin/order/shopping/order/${ordIdx}`, params).then(({data}) => data);
        },
        getOrderWaitInfo(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaGet(`v1/admin/order/shopping/wait/${ordIdx}`, params).then(({data}) => data);
        },
        getOrderReadyInfo(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaGet(`v1/admin/order/shopping/ready/${ordIdx}`, params).then(({data}) => data);
        },
        getOrderCancel(params) {
            return request.javaGet(`v1/admin/order/shopping/withdraw/cancel`, params).then(({data}) => data);
        },
        getOrderChangeRequest(params) {
            return request.javaGet(`v1/admin/order/shopping/withdraw/change/request`, params).then(({data}) => data);
        },
        getOrderChangeDetail(params) {
            let otIdx = params.otIdx;
            delete params.otIdx;
            return request.javaGet(`v1/admin/order/shopping/withdraw/change/${otIdx}`, params).then(({data}) => data);
        },
        getOrderChangeAccept(params) {
            return request.javaGet(`v1/admin/order/shopping/withdraw/change/accept`, params).then(({data}) => data);
        },
        getOrderChangeDeny(params) {
            return request.javaGet(`v1/admin/order/shopping/withdraw/change/reject`, params).then(({data}) => data);
        },
        getOrderWait(params) {
            return request.javaGet(`v1/admin/order/shopping/wait`, params).then(({data}) => data);
        },
        getOrderDelivery(params) {
            return request.javaGet(`v1/admin/order/shopping/delivery`, params).then(({data}) => data);
        },
        getOrderEnd(params) {
            return request.javaGet(`v1/admin/order/shopping/end`, params).then(({data}) => data);
        },
        changeOrderReady(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx
            return request.javaPatch(`v1/admin/order/product-ready/${ordIdx}`, params).then(({data}) => data);
        },

        //100
        cancelPayment(params) {
            return request.javaPut(`v1/admin/order/update`, params).then(({data}) => data);
        },

        //배송완료처리 단품
        changeOrderShipDone(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/ship-done/${ordIdx}`, params).then(({data}) => data);
        },

        //반품중
        changeOrderRefund(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/refund/processing/${ordIdx}`, params).then(({data}) => data);
        },
        //교환중
        changeOrderTradeProcessing(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/trade/processing/${ordIdx}`, params).then(({data}) => data);
        },
        //반품완료
        changeOrderRefundDone(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/refund/done/${ordIdx}`, params).then(({data}) => data);
        },
        //교환완료
        changeOrderTradeDone(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/trade/done/${ordIdx}`, params).then(({data}) => data);
        },


        //배송대기
        changeOrderShipReady(params) {
            return request.javaPatch('v1/admin/order/ship-ready', params).then(({data}) => data);
        },
        //배송대기
        changeOrderShipReadyOne(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/ship-ready/${ordIdx}`, params).then(({data}) => data);
        },
        changeOrderDone(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/done/${ordIdx}`, params).then(({data}) => data);
        },
        changeOrderDoneMulti(params) {
            return request.javaPatch('v1/admin/order/done', params).then(({data}) => data);
        },
        changeOrderCancelMulti(params) {
            return request.javaPatch('v1/admin/order/shopping/cancel', params).then(({data}) => data);
        },
        changeOrderDelivering(params) {
            return request.javaPatch('v1/admin/order/shipping', params).then(({data}) => data);
        },
        changeOrderShipDoneMulti(params) {
            return request.javaPatch('v1/admin/order/ship-done', params).then(({data}) => data);
        },
        //입금 취소
        orderDepositCancel(params) {
            return request.javaDelete('v1/admin/order/deposit/cancel', params).then(({data}) => data);
        },
        //입금 취소 다중
        orderDepositMultiCancel(params) {
            return request.javaDelete('v1/admin/order/deposit/multi-cancel', params).then(({data}) => data);
        },
        //상품 처리 중 다중
        orderProductMultiReady(params) {
            return request.javaPatch('v1/admin/order/product-ready', params).then(({data}) => data);
        },
        changeOrderDelivery(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPut(`v1/admin/order/${ordIdx}/address`, params).then(({data}) => data);
        },
        //자바 운송장 번호
        changeOrderExpress(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaPut(`v1/admin/cart/express/${caIdx}`, params).then(({data}) => data);
        },

        changeOrderMemo(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/memo/${ordIdx}`, params).then(({data}) => data);
        },
        getExpress(params) {
            return request.javaGet('v1/admin/express/category', params).then(({data}) => data);
        },
        getExpressReason(params) {
            return request.javaGet('v1/admin/express/reason', params).then(({data}) => data);
        },

        refundAccept(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/refund/${ordIdx}/accept`, params).then(({data}) => data);
        },
        refundReject(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/refund/${ordIdx}/reject`, params).then(({data}) => data);
        },
        tradeAccept(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/trade/${ordIdx}/accept`, params).then(({data}) => data);
        },
        tradeReject(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/trade/${ordIdx}/reject`, params).then(({data}) => data);
        },
        //배송중 상세
        getOrderDeliveryDetail(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaGet(`v1/admin/order/shopping/delivery/${ordIdx}`, params).then(({data}) => data);
        },
        //배송완료 상세
        getOrderDoneDetail(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaGet(`v1/admin/order/shopping/end/${ordIdx}`, params).then(({data}) => data);
        },


        createShopping(params) {
            return request.javaPost("v1/admin/media/shop", params).then(({data}) => data);
        },
        updateShopping(params) {
            return request.javaPut("v1/admin/media/shop", params).then(({data}) => data);
        },
        deleteShopping(params) {
            return request.javaDelete("v1/admin/media/shop", params).then(({data}) => data);
        },

        acceptShopping(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaPut(`v1/admin/media/shop/approval/${meIdx}`, params).then(({data}) => data);
        },
        rejectShopping(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaPut(`v1/admin/media/shop/reject/${meIdx}`, params).then(({data}) => data);
        },

        changeOrderTradeRequest(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/trade/${ordIdx}`, params).then(({data}) => data);
        },

        changeOrderRefundRequest(params) {
            let ordIdx = params.ordIdx;
            delete params.ordIdx;
            return request.javaPatch(`v1/admin/order/refund/${ordIdx}`, params).then(({data}) => data);
        },
        moveShopping(params){
            return request.javaPost("v1/admin/media/move/shop", params).then(({data}) => data);
        }
    },
    $menu: {
        getNormalMenu(params) {
            return request.javaGet("v1/admin/media/category/list", params).then(({data}) => data);
        },
        getMediaAdmCategory(params) {
            return request.javaGet("v1/admin/media/adm/category", params).then(({data}) => data);
        },
        getMenuDetail(params) {
            let mcIdx = params.mcIdx;
            delete params.mcIdx;
            return request.javaGet(`v1/admin/media/menu/${mcIdx}`, params).then(({data}) => data);
        },
        getOttMenu(params) {
            return request.javaGet("v1/admin/media/menu/ott", params).then(({data}) => data);
        },
        getOttMenuDetail(params) {
            let mcIdx = params.mcIdx;
            delete params.mcIdx;
            return request.javaGet(`v1/admin/media/menu/ott/${mcIdx}`, params).then(({data}) => data);
        },
        createMenu(params) {
            return request.javaPost("v1/admin/media/category", params).then(({data}) => data);
        },
        updateMenu(params) {
            let mcIdx = params.mcIdx;
            delete params.mcIdx;
            return request.javaPut(`v1/admin/media/category/${mcIdx}`, params).then(({data}) => data);
        },
        deleteMenuMulti(params) {
            return request.javaDelete("v1/admin/media/category", params).then(({data}) => data);
        },
        deleteMenu(params) {
            let mgIdx = params.mgIdx;
            delete params.mgIdx;
            return request.javaDelete(`v1/admin/media/category/genre/${mgIdx}`, params).then(({data}) => data);
        },
        getGameMenu(params) {
            return request.javaGet("v1/admin/game/menu", params).then(({data}) => data);
        },
        getGameMenuDetail(params) {
            let gaIdx = params.gaIdx;
            delete params.gaIdx;
            return request.javaGet(`v1/admin/game/menu/${gaIdx}`, params).then(({data}) => data);
        },
        createGameMenu(params) {
            return request.javaPost('v1/admin/game/menu', params).then(({data}) => data);
        },
        updateGameMenu(params) {
            let gaIdx = params.gaIdx;
            delete params.gaIdx;
            return request.javaPut(`v1/admin/game/menu/${gaIdx}`, params).then(({data}) => data);
        },
        deleteMultiGameMenu(params) {
            return request.javaDelete("v1/admin/game/menu", params).then(({data}) => data);
        },
        getLocationMenu(params) {
            return request.javaGet("v1/admin/class/area", params).then(({data}) => data);
        },
        getLocationMenuDetail(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaGet(`v1/admin/class/area/${caIdx}`, params).then(({data}) => data);
        },
        deleteMultipleLocationMenu(params) {
            return request.javaDelete("v1/admin/class/area", params).then(({data}) => data);
        },
        createLocationMenu(params) {
            return request.javaPost('v1/admin/class/area', params).then(({data}) => data);
        },
        updateLocationMenu(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaPut(`v1/admin/class/area/${caIdx}`, params).then(({data}) => data);
        },
        getGenreSetting(params) {
            return request.javaGet('v1/admin/media/genre', params).then(({data}) => data);
        },
        deleteGenreSetting(params) {
            let mgIdx = params.mgIdx;
            delete params.mgIdx;
            return request.javaDelete(`v1/admin/media/category/genre/${mgIdx}`, params).then(({data}) => data);
        },
        createGenreSetting(params) {
            let mcIdx = params.mcIdx;
            delete params.mcIdx;
            return request.javaPost(`v1/admin/media/category/${mcIdx}/genre`, params).then(({data}) => data);
        },
        updateGenreSetting(params) {
            let mgIdx = params.mgIdx;
            delete params.mgIdx;
            return request.javaPut(`v1/admin/media/category/genre/${mgIdx}`, params).then(({data}) => data);
        },
    },
    $volume: {
        getVolume(params) {
            return request.javaGet("v1/admin/mobile-upload-volume", params).then(({data}) => data);
        },
        updateVolume(params) {
            return request.javaPut("v1/admin/mobile-upload-volume", params).then(({data}) => data);
        },
    },
    $terms: {
        getTermsCategory(params) {
            return request.javaGet('v2/admin/CMS/config/category', params).then(({data}) => data)
        },
        getTerms(params) {
            return request.javaGet('v1/admin/config', params).then(({data}) => data)
        },
        getTermsInfo(params) {
            let coIdx = params.coIdx;
            delete params.coIdx;
            return request.javaGet(`v1/admin/CMS/config/${coIdx}`, params).then(({data}) => data)
        },
        createTermsCategory(params) {
            return request.javaPost(`v2/admin/CMS/config/category`, params).then(({data}) => data)
        },
        updateTermsCategory(params) {
            let id = params.id;
            delete params.id;
            return request.javaPut(`v2/admin/CMS/config/category/${id}`, params).then(({data}) => data)
        },
        deleteTermsCategory(params) {
            let id = params.id;
            delete params.id;
            return request.javaDelete(`v1/admin/CMS/config/category/${id}`, params).then(({data}) => data)
        },
    },
    $order: {
        createCart(params) {
            return request.javaPost('v1/admin/cart', params).then(({data}) => data);
        },
        checkOrder(params) {
            return request.javaGet(`v1/order/inis/WEB/chk/pay`, params).then(({data}) => data);
        },
        createOrder(params) {
            return request.javaPost('v1/admin/order', params).then(({data}) => data);
        },
    },
    $point: {

        getPointMember(params) {
            let mbNo = params.mbNo;
            delete params.mbNo;
            return request.javaGet(`v1/admin/member-partner/point/${mbNo}`, params).then(({data}) => data);
        },
    },
    $coin: {
        getPartnerCoin(params) {
            let mbNo = params.mbNo;
            delete params.mbNo;
            return request.javaGet(`v1/admin/member-partner/coin/${mbNo}`, params).then(({data}) => data);
        },
        getCoinCategory(params) {
            return request.javaGet(`v1/admin/coin/category`, params).then(({data}) => data);
        },
    },
    $history: {
        getCoinHistory(params) {
            return request.javaGet(`v1/admin/history/usage/coins`, params).then(({data}) => data);
        },
        getPointHistory(params) {
            return request.javaGet(`v1/admin/point/usage`, params).then(({data}) => data);
        },
        getGoldHistory(params) {
            return request.javaGet(`v1/admin/history/usage/gold`, params).then(({data}) => data);
        },
        getPartnerGold(params) {
            let mbNo = params.mbNo;
            delete params.mbNo;
            return request.javaGet(`v1/admin/member-partner/gold/${mbNo}`, params).then(({data}) => data);
        },
        getPrize(params) {
            return request.javaGet(`v2/admin/prize`, params).then(({data}) => data);
        },
        getPrizeDetail(params) {
            let prIdx = params.prIdx;
            delete params.prIdx;
            return request.javaGet(`v2/admin/prize/${prIdx}`, params).then(({data}) => data);
        },
        getPrizeTrade(params) {
            return request.javaGet(`v1/admin/trade/history`, params).then(({data}) => data);
        },
        getPrizeTradeDetail(params) {
            let pthIdx = params.pthIdx;
            delete params.pthIdx;
            return request.javaGet(`v2/admin/prize/trade-history-detail/${pthIdx}`, params).then(({data}) => data);
        },
        getPrizeTradeMember(params) {
            return request.javaGet(`v1/admin/members/trade`, params).then(({data}) => data);
        },
        getAgainMallTradeHistoryList(params) {
            return request.javaGet(`v1/admin/again/trade`, params).then(({data}) => data);
        },
        createPrize(params) {
            return request.javaPost(`v2/admin/prize`, params).then(({data}) => data);
        },
        updatePrize(params) {
            let prIdx = params.prIdx;
            delete params.prIdx;
            return request.javaPut(`v2/admin/prize/${prIdx}`, params).then(({data}) => data);
        },
        deletePrize(params) {
            let prIdx = params.prIdx;
            delete params.prIdx;
            return request.javaDelete(`v1/admin/prize/${prIdx}`, params).then(({data}) => data);
        },
        updatePrizeTrade(params) {
            let pthIdx = params.pthIdx;
            delete params.pthIdx;
            return request.javaPut(`v1/admin/prize/trade/history/${pthIdx}`, params).then(({data}) => data);
        },
        cancelTrade(params) {
            let pthIdx = params.pthIdx;
            delete params.pthIdx;
            return request.javaPatch(`v2/admin/prize/trade/history/cancel/${pthIdx}`, params).then(({data}) => data);
        },
        getPointCategory(params) {
            return request.javaGet(`v1/admin/point/define`, params).then(({data}) => data);
        },
        getPrizeCategory(params) {
            return request.javaGet(`v2/admin/prize/category`, params).then(({data}) => data);
        },


        getAffiliate(params) {
            return request.javaGet(`v1/admin/media/shop/trade-history`, params).then(({data}) => data);
        },

        getAffiliateDetail(params) {
            let msthIdx = params.msthIdx;
            delete params.msthIdx;
            return request.javaGet(`v1/admin/media/shop/trade-history/${msthIdx}`, params).then(({data}) => data);
        },
        updateAffiliate(params) {
            let msthIdx = params.msthIdx;
            delete params.msthIdx;
            return request.javaPut(`v1/admin/media/shop/trade-history/${msthIdx}`, params).then(({data}) => data);
        },
        cancelAffiliate(params) {
            let msthIdx = params.msthIdx;
            delete params.msthIdx;
            return request.javaPut(`v1/admin/media/shop/trade-history/${msthIdx}/cancel`, params).then(({data}) => data);
        },

        getPrizeCategoryList(params) {
            return request.javaGet(`v2/admin/prize/category`, params).then(({data}) => data);
        },
        getPrizeCategoryInfo(params) {
            let pcIdx = params.pcIdx;
            delete params.pcIdx;
            return request.javaGet(`v2/admin/prize/category/${pcIdx}`, params).then(({data}) => data);
        },
        createPrizeCategory(params) {
            return request.javaPost(`v2/admin/prize/category`, params).then(({data}) => data);
        },

        updatePrizeCategory(params) {
            let pcIdx = params.pcIdx;
            delete params.pcIdx;
            return request.javaPut(`v2/admin/prize/category/${pcIdx}`, params).then(({data}) => data);
        },

        deletePrizeCategory(params) {
            return request.javaDelete(`v2/admin/prize/category`, params).then(({data}) => data);
        },

        deletePrizeCategoryItem(params) {
            let pcIdx = params.pcIdx;
            delete params.pcIdx;
            return request.javaDelete(`v1/admin/prize/categories/${pcIdx}`, params).then(({data}) => data);
        },

        getHistoryVod(params) {
            return request.javaGet(`v1/admin/media/vod/trade-history`, params).then(({data}) => data);
        },
        getHistoryVodDetail(params) {
            let mvthIdx = params.mvthIdx;
            delete params.mvthIdx;
            return request.javaGet(`v1/admin/media/vod/trade-history/${mvthIdx}`, params).then(({data}) => data);
        },
        cancelHistoryVod(params) {
            let mvthIdx = params.mvthIdx;
            delete params.mvthIdx;
            return request.javaPut(`v1/admin/media/vod/trade-history/${mvthIdx}/cancel`, params).then(({data}) => data);
        },
        getAgainCategoryList(params) {
            return request.javaGet(`v1/admin/again/category`, params).then(({data}) => data);
        },
        deleteAgainCategory(params) {
            return request.javaDelete(`v1/admin/again/category`, params).then(({data}) => data);
        },
        createAgainCategory(params) {
            return request.javaPost(`v1/admin/again/category`, params).then(({data}) => data);
        },
        getAgainCategoryInfo(params) {
            let ampcIdx = params.ampcIdx;
            delete params.ampcIdx;
            return request.javaGet(`v1/admin/again/category/${ampcIdx}`, params).then(({data}) => data);
        },
        updateAgainCategory(params) {
            let ampcIdx = params.ampcIdx;
            delete params.ampcIdx;
            return request.javaPut(`v1/admin/again/category/${ampcIdx}`, params).then(({data}) => data);
        },
        getAgainPrize(params) {
            return request.javaGet(`v1/admin/again`, params).then(({data}) => data);
        },
        createAgainPrize(params) {
            return request.javaPost(`v1/admin/again`, params).then(({data}) => data);
        },
        getAgainPrizeInfo(params) {
            let amprIdx = params.amprIdx;
            delete params.amprIdx;
            return request.javaGet(`v1/admin/again/${amprIdx}`, params).then(({data}) => data);
        },
        updateAgainPrize(params) {
            let amprIdx = params.amprIdx;
            delete params.amprIdx;
            return request.javaPut(`v1/admin/again/${amprIdx}`, params).then(({data}) => data);
        },
        deleteAgainPrize(params) {
            let amprIdx = params.amprIdx;
            delete params.amprIdx;
            return request.javaDelete(`v1/admin/again/${amprIdx}`, params).then(({data}) => data);
        },
        getAgainPrizeTrade(params) {
            return request.javaGet(`v1/admin/again/trade`, params).then(({data}) => data);
        },
        getAgainPrizeTradeInfo(params) {
            let ampthIdx = params.ampthIdx;
            delete params.ampthIdx;
            return request.javaGet(`v1/admin/again/trade/${ampthIdx}`, params).then(({data}) => data);
        },
        updateAgainPrizeTrade(params) {
            let ampthIdx = params.ampthIdx;
            delete params.ampthIdx;
            return request.javaPut(`v1/admin/again/trade/${ampthIdx}`, params).then(({data}) => data);
        },
        cancelAgainPrizeTrade(params) {
            let ampthIdx = params.ampthIdx;
            delete params.ampthIdx;
            return request.javaPost(`v1/admin/again/trade/${ampthIdx}/cancel`, params).then(({data}) => data);
        },
    },
    $bf:{
        async getStaticNeighborPartnerPartnerTypeRegister(params) {
            return request.getJavaStatistics(`v1/statistics/static-partners/register/partner-type/monthly`, params).then(({data}) => data);
        },
        async getStaticNeighborPartnerPartnerTypeUser(params) {
            return request.getJavaStatistics(`v1/statistics/static-partners/user/partner-type/monthly`, params).then(({data}) => data);
        },

        async getStaticNeighborPartnerDeviceRegister(params) {
            return request.getJavaStatistics(`v1/statistics/static-partners/register/device/monthly`, params).then(({data}) => data);
        },
        async getStaticNeighborPartnerDeviceRegisterLogin(params) {
            return request.getJavaStatistics(`v1/statistics/static-partners/register-login/device/monthly`, params).then(({data}) => data);
        },
        async getStaticNeighborPartnerDeviceUser(params) {
            return request.getJavaStatistics(`v1/statistics/static-partners/user/device/monthly`, params).then(({data}) => data);
        },

        async getStaticNeighborPartnerSoRegister(params) {
            return request.getJavaStatistics(`v1/statistics/static-partners/register/monthly`, params).then(({data}) => data);
        },
        async getStaticNeighborPartnerSoUser(params) {
            return request.getJavaStatistics(`v1/statistics/static-partners/user/monthly`, params).then(({data}) => data);
        },

        async getStaticVideoContentContentUploadDefault(params) {
            return request.getJavaStatistics(`v1/statistics/static-contents/video/upload/monthly`, params).then(({data}) => data);
        },
        async getStaticVideoContentContentDeleteDefault(params) {
            return request.getJavaStatistics(`v1/statistics/static-contents/video/delete/monthly`, params).then(({data}) => data);
        },
        async getStaticVideoContentContentWatchDefault(params) {
            return request.getJavaStatistics(`v1/statistics/static-contents/video/watch/monthly`, params).then(({data}) => data);
        },
        async getStaticVideoContentContentWatchUserDefault(params) {
            return request.getJavaStatistics(`v1/statistics/static-contents/video/watch-user/monthly`, params).then(({data}) => data);
        },


        async getStaticAdContentContentUploadDefault(params) {
            return request.getJavaStatistics('v1/statistics/static-ads/upload-contents/monthly', params).then(({data}) => data);
        },
        async getStaticAdContentContentDeleteDefault(params) {
            return request.getJavaStatistics('v1/statistics/static-ads/delete-contents/monthly', params).then(({data}) => data);
        },
        async getStaticAdContentContentWatchDefault(params) {
            return request.getJavaStatistics('v1/statistics/static-ads/watch/monthly', params).then(({data}) => data);
        },
        async getStaticAdContentContentWatchUserDefault(params) {
            return request.getJavaStatistics('v1/statistics/static-ads/watch-user/monthly', params).then(({data}) => data);
        },

        async getGameBfGameUserDefault(params) {
            return request.getJavaStatistics(`v1/statistics/games/user/monthly`, params).then(({data}) => data);
        },
        async getGameBfGameUserDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/games/user/quarterly`, params).then(({data}) => data);
        },
        async getGameBfUserTimeDefault(params) {
            return request.getJavaStatistics(`v1/statistics/games/user-time/monthly`, params).then(({data}) => data);
        },
        async getGameBfUserTimeDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/games/user-time/quarterly`, params).then(({data}) => data);
        },
        async getStaticShoppingContentWatchDefault(params) {
            return request.getJavaStatistics('v1/statistics/static-contents/shop/watch/monthly', params).then(({data}) => data);
        },
        async getStaticShoppingContentWatchUserDefault(params) {
            return request.getJavaStatistics('v1/statistics/static-contents/shop/watch-user/monthly', params).then(({data}) => data);
        },
        async getStaticShoppingContentUploadDefault(params) {
            return request.getJavaStatistics('v1/statistics/static-contents/shop/upload/monthly', params).then(({data}) => data);
        },
        async getStaticShoppingContentDeleteContentsDefault(params) {
            return request.getJavaStatistics('v1/statistics/static-contents/shop/delete/monthly', params).then(({data}) => data);
        },
        async getVideoContentContentUploadDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/upload/monthly`, params).then(({data}) => data);
        },
        async getVideoContentContentUploadDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/upload/quarterly`, params).then(({data}) => data);
        },
        async getVideoContentContentAllowDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/allow/monthly`, params).then(({data}) => data);
        },
        async getVideoContentContentAllowDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/allow/quarterly`, params).then(({data}) => data);
        },
        async getVideoContentContentPendingDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/pending/monthly`, params).then(({data}) => data);
        },
        async getVideoContentContentPendingDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/pending/quarterly`, params).then(({data}) => data);
        },
        async getVideoContentContentAllowTimeDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/allow-time/monthly`, params).then(({data}) => data);
        },
        async getVideoContentContentAllowTimeDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/allow-time/quarterly`, params).then(({data}) => data);
        },
        async getVideoContentContentUpdateDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/update/monthly`, params).then(({data}) => data);
        },
        async getVideoContentContentUpdateDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/update/quarterly`, params).then(({data}) => data);
        },
        async getVideoContentContentDeleteDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/delete/monthly`, params).then(({data}) => data);
        },
        async getVideoContentContentDeleteDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/delete/quarterly`, params).then(({data}) => data);
        },
        async getVideoContentContentWatchDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/watch/monthly`, params).then(({data}) => data);
        },
        async getVideoContentContentWatchDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/watch/quarterly`, params).then(({data}) => data);
        },
        async getVideoContentContentWatchUserDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/watches/monthly`, params).then(({data}) => data);
        },
        async getVideoContentContentWatchUserDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/watches/quarterly`, params).then(({data}) => data);
        },
        async getVideoContentContentVolumeDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/volume/monthly`, params).then(({data}) => data);
        },
        async getVideoContentContentVolumeDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/volume/quarterly`, params).then(({data}) => data);
        },

        //SHOPPING
        async getShoppingContentContentUploadDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/upload/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentUploadDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/upload/quarterly`, params).then(({data}) => data);
        },
        async getShoppingContentContentAllowDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/allow/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentAllowDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/allow/quarterly`, params).then(({data}) => data);
        },
        async getShoppingContentContentPendingDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/pending/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentPendingDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/pending/quarterly`, params).then(({data}) => data);
        },
        async getShoppingContentContentAllowTimeDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/allow-time/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentAllowTimeDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/allow-time/quarterly`, params).then(({data}) => data);
        },
        async getShoppingContentContentUpdateDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/update/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentUpdateDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/update/quarterly`, params).then(({data}) => data);
        },
        async getShoppingContentContentDeleteDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/delete/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentDeleteDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/delete/quarterly`, params).then(({data}) => data);
        },
        async getShoppingContentContentWatchDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/watch/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentWatchDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/watch/quarterly`, params).then(({data}) => data);
        },
        async getShoppingContentContentWatchUserDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/watches/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentWatchUserDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/watches/quarterly`, params).then(({data}) => data);
        },
        async getShoppingContentContentVolumeDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/volume/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentVolumeDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/volume/quarterly`, params).then(({data}) => data);
        },

        async getShoppingContentContentProfitSo(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/profit/so/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentProfitSoQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/profit/so/quarterly`, params).then(({data}) => data);
        },
        async getShoppingContentContentProfitUser(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/profit/user/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentProfitUserQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/profit/user/quarterly`, params).then(({data}) => data);
        },
        async getShoppingContentContentProfitDirectDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/profit/direct/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentProfitDirectDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/profit/direct/quarterly`, params).then(({data}) => data);
        },
        async getShoppingContentContentDeliveryDefault(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/delivery/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentContentDeliveryDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/delivery/quarterly`, params).then(({data}) => data);
        },

        //ads
        async getAdvertiseContentContentUploadDefault(params) {
            return request.getJavaStatistics(`v1/statistics/ads/upload/monthly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentUploadDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/ads/upload/quarterly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentAllowDefault(params) {
            return request.getJavaStatistics(`v1/statistics/ads/allow/monthly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentAllowDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/ads/allow/quarterly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentPendingDefault(params) {
            return request.getJavaStatistics(`v1/statistics/ads/pending/monthly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentPendingDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/ads/pending/quarterly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentAllowTimeDefault(params) {
            return request.getJavaStatistics(`v1/statistics/ads/allow-time/monthly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentAllowTimeDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/ads/allow-time/quarterly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentUpdateDefault(params) {
            return request.getJavaStatistics(`v1/statistics/ads/update/monthly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentUpdateDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/ads/update/quarterly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentDeleteDefault(params) {
            return request.getJavaStatistics(`v1/statistics/ads/delete/monthly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentDeleteDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/ads/delete/quarterly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentWatchDefault(params) {
            return request.getJavaStatistics(`v1/statistics/ads/watch/monthly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentWatchDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/ads/watch/quarterly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentWatchUserDefault(params) {
            return request.getJavaStatistics(`v1/statistics/ads/watches/monthly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentWatchUserDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/ads/watches/quarterly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentVolumeDefault(params) {
            return request.getJavaStatistics(`v1/statistics/ads/volume/monthly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentVolumeDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/ads/volume/quarterly`, params).then(({data}) => data);
        },

        async getAdvertiseContentContentProfitSo(params) {
            return request.getJavaStatistics(`v1/statistics/ads/profit/so/monthly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentProfitSoQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/ads/profit/so/quarterly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentProfitUser(params) {
            return request.getJavaStatistics(`v1/statistics/ads/profit/user/monthly`, params).then(({data}) => data);
        },
        async getAdvertiseContentContentProfitUserQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/ads/profit/user/quarterly`, params).then(({data}) => data);
        },

        //live

        async getLiveChannelChannelsDefault(params) {
            return request.getJavaStatistics(`v1/statistics/lives/channels/monthly`, params).then(({data}) => data);
        },
        async getLiveChannelChannelsDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/lives/channels/quarterly`, params).then(({data}) => data);
        },
        async getLiveChannelWatchUserDefault(params) {
            return request.getJavaStatistics(`v1/statistics/lives/watch-user/monthly`, params).then(({data}) => data);
        },
        async getLiveChannelWatchUserDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/lives/watch-user/quarterly`, params).then(({data}) => data);
        },
        async getLiveChannelWatchTimeDefault(params) {
            return request.getJavaStatistics(`v1/statistics/lives/watch-time/monthly`, params).then(({data}) => data);
        },
        async getLiveChannelWatchTimeDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/lives/watch-time/quarterly`, params).then(({data}) => data);
        },
        async getLiveChannelWatchTimeSoDefault(params) {
            return request.getJavaStatistics(`v1/statistics/lives/so/watch-time/monthly`, params).then(({data}) => data);
        },
        async getLiveChannelWatchTimeSoDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/lives/so/watch-time/quarterly`, params).then(({data}) => data);
        },
        async getLiveChannelWatchDeviceSoDefault(params) {
            return request.getJavaStatistics(`v1/statistics/lives/so/watch-device/monthly`, params).then(({data}) => data);
        },
        async getLiveChannelWatchDeviceSoDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/lives/so/watch-device/quarterly`, params).then(({data}) => data);
        },
        async getLiveChannelProfitDefault(params) {
            return request.getJavaStatistics(`v1/statistics/lives/profit/monthly`, params).then(({data}) => data);
        },
        async getLiveChannelProfitDefaultQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/lives/profit/quarterly`, params).then(({data}) => data);
        },

        async getCommentCommentUsers(params) {
            return request.getJavaStatistics(`v1/statistics/comments/users/monthly`, params).then(({data}) => data);
        },
        async getCommentCommentUsersQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/comments/users/quarterly`, params).then(({data}) => data);
        },
        async getCommentCommentWriters(params) {
            return request.getJavaStatistics(`v1/statistics/comments/writers/monthly`, params).then(({data}) => data);
        },
        async getCommentCommentWritersQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/comments/writers/quarterly`, params).then(({data}) => data);
        },
        async getCommentCommentReviewsUsers(params) {
            return request.getJavaStatistics(`v1/statistics/comments/reviews/users/monthly`, params).then(({data}) => data);
        },
        async getCommentCommentReviewsUsersQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/comments/reviews/users/quarterly`, params).then(({data}) => data);
        },
        async getCommentCommentReviewsWriters(params) {
            return request.getJavaStatistics(`v1/statistics/comments/reviews/writers/monthly`, params).then(({data}) => data);
        },
        async getCommentCommentReviewsWritersQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/comments/reviews/writers/quarterly`, params).then(({data}) => data);
        },

        ...(() => {
            const fns = {};
            const types = ['Status', 'So', 'Route', 'Region', 'PartnerType', 'Gender', 'Device', 'Age'];
            const vals = ['User', 'Register', 'RegisterLogin'];
            types.forEach(type => {
                vals.forEach(val => {
                    const baseUrl = val === 'RegisterLogin' ? 'register-login' : val.toLowerCase();
                    const urlType = type === 'PartnerType' ? 'partner-type' : type.toLowerCase();
                    fns[`getNeighborPartner${type}${val}`] = async (params) => {
                        return request.getJavaStatistics(`v1/statistics/partners/${baseUrl}/${urlType}/monthly`, params).then(({data}) => data);
                    };
                    fns[`getNeighborPartner${type}${val}Quarter`] = async (params) => {
                        return request.getJavaStatistics(`v1/statistics/partners/${baseUrl}/${urlType}/quarterly`, params).then(({data}) => data);
                    };
                });
            });
            return fns;
        })(),
    },
    $statistics: {
        async getSos(params) {
            return request.getStatistics('sos', params).then(({data}) => data);
        },
        async getAreas(params) {
            return request.getStatistics('areas', params).then(({data}) => data);
        },
        async getCategories(params) {
            return request.getStatistics('content/categories', params).then(({data}) => data);
        },
        async getGenres(params) {
            return request.getStatistics('content/genres', params).then(({data}) => data);
        },

        async getGameData(params) {
            return request.getStatistics('game/data', params).then(({data}) => data);
        },
        async downloadGameData(params) {
            return request.downloadNestExcel('game/downloads', params).then(({data}) => data);
        },
        async downloadGameRawData(params) {
            return request.downloadNestExcel('game/downloads/raw', params).then(({data}) => data);
        },

        // 미사용
        async getMedias(params) {
            return request.getStatistics('content', params).then(({data}) => data);
        },
        async downloadMedias(params) {
            return request.downloadNestExcel('content/downloads', params).then(({data}) => data);
        },
        async downloadMediasRaw(params) {
            return request.downloadNestExcel('content/downloads/raw', params).then(({data}) => data);
        },
        // ---

        async getMediaData(params) {
            return request.getStatistics('content/data', params).then(({data}) => data);
        },
        async downloadMediaData(params) {
            return request.downloadNestExcel('content/data/downloads', params).then(({data}) => data);
        },
        async downloadMediaRawData(params) {
            return request.downloadNestExcel('content/data/downloads/raw', params).then(({data}) => data);
        },

        async getAds(params) {
            return request.getStatistics('ad', params).then(({data}) => data);
        },
        async downloadAds(params) {
            return request.downloadNestExcel('ad/downloads', params).then(({data}) => data);
        },
        async downloadAdsRaw(params) {
            return request.downloadNestExcel('ad/downloads/raw', params).then(({data}) => data);
        },

        async getAdData(params) {
            return request.getStatistics('ad/data', params).then(({data}) => data);
        },
        async downloadAdData(params) {
            return request.downloadNestExcel('ad/data/downloads', params).then(({data}) => data);
        },
        async downloadAdRawData(params) {
            return request.downloadNestExcel('ad/data/downloads/raw', params).then(({data}) => data);
        },

        // 미사용
        async getLives(params) {
            return request.getStatistics('live', params).then(({data}) => data);
        },
        async downloadLives(params) {
            return request.downloadNestExcel('live/downloads', params).then(({data}) => data);
        },
        async downloadLivesRaw(params) {
            return request.downloadNestExcel('live/downloads/raw', params).then(({data}) => data);
        },
        // ---

        async getLiveData(params) {
            return request.getStatistics('live/data', params).then(({data}) => data);
        },
        async downloadLiveData(params) {
            return request.downloadNestExcel('live/data/downloads', params).then(({data}) => data);
        },
        async downloadLivesRawData(params) {
            return request.downloadNestExcel('live/data/downloads/raw', params).then(({data}) => data);
        },

        // 미사용
        async getPartners(params) {
            return request.getStatistics('partner', params).then(({data}) => data);
        },
        // --
        async getPartnerData(params) {
            return request.getStatistics('partner/data', params).then(({data}) => data);
        },
        async downloadPartnerData(params) {
            return request.downloadNestExcel('partner/downloads', params).then(({data}) => data);
        },
        async downloadPartnersRaw(params) {
            return request.downloadNestExcel('partner/downloads/raw', params).then(({data}) => data);
        },

        // 보고서
        async getStaticPartnerData(params) {
            return request.getStatistics(`static-partners/data`, params).then(({data}) => data);
        },
        async getStaticContentData(params) {
            return request.getStatistics(`static-contents/data`, params).then(({data}) => data);
        },
        async getStaticAdData(params) {
            return request.getStatistics(`static-ads/data`, params).then(({data}) => data);
        },

        async downloadStaticPartnerData(params) {
            return request.downloadNestExcel(`static-partners/data/downloads`, params).then(({data}) => data);
        },
        async downloadStaticContentData(params) {
            return request.downloadNestExcel(`static-contents/data/downloads`, params).then(({data}) => data);
        },
        async downloadStaticAdData(params) {
            return request.downloadNestExcel(`static-ads/data/downloads`, params).then(({data}) => data);
        },
        async downloadRawStaticPartnerData(params) {
            return request.downloadNestExcel(`static-partners/data/downloads/raw`, params).then(({data}) => data);
        },
        async downloadRawStaticContentData(params) {
            return request.downloadNestExcel(`static-contents/data/downloads/raw`, params).then(({data}) => data);
        },
        async downloadRawStaticAdData(params) {
            return request.downloadNestExcel(`static-ads/data/downloads/raw`, params).then(({data}) => data);
        },

        async getCommentData(params) {
            return request.getStatistics('comment/data', params).then(({data}) => data);
        },
        async downloadCommentData(params) {
            return request.downloadNestExcel('comment/data/downloads', params).then(({data}) => data);
        },
        async downloadCommentRawData(params) {
            return request.downloadNestExcel('comment/data/downloads/raw', params).then(({data}) => data);
        },

        async getStaticPartnerSoUsed(params) {
            return request.getJavaStatistics(`v1/statistics/static-partners/user/monthly`, params).then(({data}) => data);
        },
        async getStaticPartnerSoRegistered(params) {
            return request.getJavaStatistics(`v1/statistics/static-partners/register/monthly`, params).then(({data}) => data);
        },
        async getStaticVideoContentDefaultContentUpload(params) {
            return request.getJavaStatistics(`v1/statistics/static-contents/video/upload/monthly`, params).then(({data}) => data);
        },
        async getStaticVideoContentDefaultContentWatch(params) {
            return request.getJavaStatistics(`v1/statistics/static-contents/video/watch/monthly`, params).then(({data}) => data);
        },
        async getStaticVideoContentDefaultContentWatchUser(params) {
            return request.getJavaStatistics(`v1/statistics/static-contents/video/watch-user/monthly`, params).then(({data}) => data);
        },
        async getStaticShoppingContentDefaultContentUpload(params) {
            return request.getJavaStatistics(`v1/statistics/static-contents/shop/upload/monthly`, params).then(({data}) => data);
        },
        async getStaticShoppingContentDefaultContentWatch(params) {
            return request.getJavaStatistics(`v1/statistics/static-contents/shop/watch/monthly`, params).then(({data}) => data);
        },
        async getStaticShoppingContentDefaultContentWatchUser(params) {
            return request.getJavaStatistics(`v1/statistics/static-contents/shop/watch-user/monthly`, params).then(({data}) => data);
        },
        async getStaticAdContentDefaultContentWatch(params) {
            return request.getJavaStatistics(`v1/statistics/static-ads/watch/monthly`, params).then(({data}) => data);
        },
        async getStaticAdContentDefaultContentWatchUser(params) {
            return request.getJavaStatistics(`v1/statistics/static-ads/watch-user/monthly`, params).then(({data}) => data);
        },


        async getVideoContentDefaultContentUpload(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/upload/monthly`, params).then(({data}) => data);
        },
        async getVideoContentDefaultContentUploadQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/video/upload/quarterly`, params).then(({data}) => data);
        },


        async getShoppingContentDefaultContentUpload(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/upload/monthly`, params).then(({data}) => data);
        },
        async getShoppingContentDefaultContentUploadQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/contents/shop/upload/quarterly`, params).then(({data}) => data);
        },

        async getLiveChannelDefaultContent(params) {
            return request.getJavaStatistics(`v1/statistics/lives/channels/monthly`, params).then(({data}) => data);
        },
        async getLiveChannelDefaultContentQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/lives/channels/quarterly`, params).then(({data}) => data);
        },
        async getLiveChannelDefaultContentWatchUser(params) {
            return request.getJavaStatistics(`v1/statistics/lives/watch-user/monthly`, params).then(({data}) => data);
        },
        async getLiveChannelDefaultContentWatchUserQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/lives/watch-user/quarterly`, params).then(({data}) => data);
        },


        async getGameUser(params) {
            return request.getJavaStatistics(`v1/statistics/games/user/monthly`, params).then(({data}) => data);
        },
        async getGameUserQuarter(params) {
            return request.getJavaStatistics(`v1/statistics/games/user/quarterly`, params).then(({data}) => data);
        },
    },
    $ga: {
        allowContentStatistics(params) {
            return request.putJavaStatistics('v1/statistics/contents/allow', params).then(({data}) => data);
        },
        statisticsMemberUpdate(params) {
            return request.gaPost('statistics/member/info/update', params).then(({data}) => data);
        },
        statisticsContentCreate(params) {
            return request.postJavaStatistics('v1/statistics/contents', params).then(({data}) => data);
        },
        statisticsContentUpdate(params) {
            return request.putJavaStatistics('v1/statistics/contents', params).then(({data}) => data);
        },
        statisticsContentTypeUpdate(params) {
            return request.postJavaStatistics('v1/statistics/contents/reason', params).then(({data}) => data);
        },
        statisticsContentDelete(params) {
            return request.deleteJavaStatistics('v1/statistics/contents/reason', params).then(({data}) => data);
        },
        statisticsAdCreate(params) {
            return request.gaPost('statistics/ad', params).then(({data}) => data);
        },
        statisticsAdUpdate(params) {
            return request.putJavaStatistics('v1/statistics/ads/watch', params).then(({data}) => data);
        },
        statisticsAdTypeUpdate(params) {
            return request.postJavaStatistics('v1/statistics/ads/reason', params).then(({data}) => data);
        },
        statisticsAdAllow(params) {
            return request.postJavaStatistics('v1/statistics/ads/allow', params).then(({data}) => data);
        },
        statisticsAdDelete(params) {
            return request.deleteJavaStatistics('v1/statistics/ads/reason', params).then(({data}) => data);
        },
        statisticsLiveCreate(params) {
            return request.postJavaStatistics('v1/statistics/lives', params).then(({data}) => data);
        },
        statisticsLiveUpdate(params) {
            return request.postJavaStatistics('v1/statistics/lives/info', params).then(({data}) => data);
        },
        statisticsLiveDelete(params) {
            return request.gaPost('statistics/live/delete', params).then(({data}) => data);
        },
    },
    $excel: {
        createDownloadHistory(params) {
            return request.javaPost("v1/admin/download/history", params).then(({data}) => data);
        },
    },
    $banner: {
        getBanner(params) {
            return request.javaGet('v2/admin/banner/list', params).then(({data}) => data);
        },
        createBanner(params) {
            return request.javaPost("v2/admin/pop-up", params).then(({data}) => data);
        },
        updateBanner(params) {
            let baIdx = params.baIdx;
            delete params.baIdx;
            return request.javaPut(`v2/admin/pop-up/${baIdx}`, params).then(({data}) => data);
        },
         createAiBanner(params) {
            return request.javaPost("v2/admin/pop-up/ai", params).then(({data}) => data);
        },
        updateAiBanner(params) {
            let baIdx = params.baIdx;
            delete params.baIdx;
            return request.javaPut(`v2/admin/pop-up/ai/${baIdx}`, params).then(({data}) => data);
        },
        deleteBanner(params) {
            let baIdx = params.baIdx;
            delete params.baIdx;
            return request.javaDelete(`v2/admin/pop-up/${baIdx}`, params).then(({data}) => data);
        },
        getSetting(params) {
            let bsManageType = params.bsManageType;
            delete params.bsManageType;
            return request.javaGet(`v2/admin/banner/setting/${bsManageType}`, params).then(({data}) => data);
        },
        updateSetting(params) {
            return request.javaPut('v2/admin/pop-up/fixed/size', params).then(({data}) => data);
        },
        updateSettingAi(params) {
            return request.javaPut('v2/admin/pop-up/ai/size', params).then(({data}) => data);
        },
        getPopupSetting(params) {
            return request.javaGet(`v2/admin/popup/setting`, params).then(({data}) => data);
        },
        putPopupSetting(params) {
            return request.javaPut(`v2/admin/pop-up/setting`, params).then(({data}) => data);
        },
        deleteAiBanner(params) {
            let baIdx = params.baIdx;
            delete params.baIdx;
            return request.javaDelete(`v2/admin/pop-up/ai/${baIdx}`, params).then(({data}) => data);
        },


    },
    $live: {
        getLive(params) {
            return request.javaGet(`v1/admin/channel`, params).then(({data}) => data);
        },

        getCableLive(params) {
            return request.javaGet(`v1/admin/channel/cable`, params).then(({data}) => data);
        },
        getChannelBundleComponent(params) {
            let cbIdx = params.cbIdx;
            delete params.cbIdx
            return request.javaGet(`v1/admin/channel/bundle/component/${cbIdx}`, params).then(({data}) => data);
        },
        getPaidLiveDetail(params) {
            let caIdx = params.caIdx;
            delete params.caIdx
            return request.javaGet(`v1/admin/channel/premium/${caIdx}/detail`, params).then(({data}) => data);
        },
        getCableChannelSchedule(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaGet(`v1/admin/channel/cable/${caIdx}/schedules`, params).then(({data}) => data);
        },

        //실시간 라이브
        getLiveMonitoring(params) {
            return request.javaGet(`v1/admin/channel/contents/monitoring/realtime-live`, params).then(({data}) => data);
        },
        //레T
        getLiveCableTvMonitoring(params) {
            return request.javaGet(`v1/admin/channel/contents/monitoring/cable-tv`, params).then(({data}) => data);
        },
        //유료 채널
        getLivePaidMonitoring(params) {
            return request.javaGet(`v1/admin/channel/contents/monitoring/premium-channel`, params).then(({data}) => data);
        },
        //콘텐츠 라이브
        getLiveContentMonitoring(params) {
            return request.javaGet(`v1/admin/channel/contents/monitoring/content-live`, params).then(({data}) => data);
        },
        //우방
        getLiveWoobangMonitoring(params) {
            return request.javaGet(`v1/admin/channel/contents/monitoring/woobang-live`, params).then(({data}) => data);
        },
        getPaidLive(params) {
            return request.javaGet(`v1/admin/channel/premium`, params).then(({data}) => data);
        },
        getLiveDetail(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaGet(`v1/admin/channel/${caIdx}`, params).then(({data}) => data);
        },
        getCableLiveDetail(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaGet(`v1/admin/channel/cable/${caIdx}/detail`, params).then(({data}) => data);
        },
        getCableImpossibleTime(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaGet(`v1/admin/channel/cable/${caIdx}/detail/imp`, params).then(({data}) => data);
        },
        getLiveGenreCategory(params) {
            return request.javaGet("v1/public/channel/genre", params).then(({data}) => data);
        },
        createLive(params) {
            return request.javaPost('v1/admin/channel', params).then(({data}) => data);
        },
        createLiveAlacarte(params) {
            return request.javaPost('v1/admin/channel/alaca', params).then(({data}) => data);
        },
        createPaidLive(params) {
            return request.javaPost('v1/admin/channel/paid', params).then(({data}) => data);
        },
        updatePaidLive(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaPut(`v1/admin/channel/paid/${caIdx}`, params).then(({data}) => data);
        },
        deletePaidLive(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaDelete(`v1/admin/channel/paid/${caIdx}`, params).then(({data}) => data);
        },
        updateLive(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaPut(`v1/admin/channel/${caIdx}`, params).then(({data}) => data);
        },
        updateCableLive(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaPut(`v1/admin/channel/alaca/${caIdx}`, params).then(({data}) => data);
        },
        deleteLive(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaDelete(`v1/admin/channel/${caIdx}`, params).then(({data}) => data);
        },
        deleteCableLive(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaDelete(`v1/admin/channel/alaca/${caIdx}`, params).then(({data}) => data);
        },
        //TODO 리팩토링용 임시 주석
        // getContentLive(params) {
        //     return request.get(`fast/channel`, params).then(({data}) => data);
        // },
        getContentLive(params) {
            return request.javaGet(`v1/admin/channel/contents`, params).then(({data}) => data);
        },
        getContentLiveDetail(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx;
            return request.javaGet(`v1/admin/channel/contents/${fcIdx}/detail`, params).then(({data}) => data);
        },
        getPaidChannelBundle(params) {
            return request.javaGet(`v1/admin/channel/bundle`, params).then(({data}) => data);
        },
        getPaidChannelBundleDetail(params) {
            let cbIdx = params.cbIdx;
            delete params.cbIdx;
            return request.javaGet(`v1/admin/channel/bundle/${cbIdx}`, params).then(({data}) => data);
        },
        createTransmissionImpossible(params) {
            return request.javaPost('v1/admin/channel/impassible', params).then(({data}) => data);
        },
        deleteTransmissionImpossible(params) {
            return request.javaPost('v1/admin/channel/impassible/delete', params).then(({data}) => data);
        },
        getChannelSchedule(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaGet(`v1/admin/channel/${caIdx}/schedule`, params).then(({data}) => data);
        },
        getPaidChannelSchedule(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            return request.javaGet(`v1/admin/channel/premium/${caIdx}/schedule`, params).then(({data}) => data);
        },
        getChannelScheduleDetail(params) {
            let caIdx = params.caIdx;
            delete params.caIdx;
            let csIdx = params.csIdx;
            delete params.csIdx;
            return request.javaGet(`v1/admin/channel/${caIdx}/schedule/${csIdx}`, params).then(({data}) => data);
        },
        createChannelSchedule(params) {
            params.csStartTime = params.csStartTime.replace(" ", "T");
            params.csEndTime = params.csEndTime.replace(" ", "T")
            return request.javaPost(`v1/admin/channel/schedule`, params).then(({data}) => data);
        },
        updateChannelSchedule(params) {
            params.csStartTime = params.csStartTime.replace(" ", "T");
            params.csEndTime = params.csEndTime.replace(" ", "T")
            let csIdx = params.csIdx;
            delete params.csIdx;
            return request.javaPut(`v1/admin/channel/schedule/${csIdx}`, params).then(({data}) => data);
        },
        deleteChannelSchedule(params) {
            let csIdx = params.csIdx;
            delete params.csIdx;
            return request.javaDelete(`v1/admin/channel/schedule/${csIdx}`, params).then(({data}) => data);
        },
        //엑셀 업로드
        excelAdd(params) {
            return request.multipartPost(`v1/admin/channel/xlsx/upload`, {}, params.file).then(({data}) => data);
        },
        excelAddPremium(params) {
            return request.multipartGet(`v1/admin/channel/cable/xlsx`, {}, params.file).then(({data}) => data);
        },
        excelAddCable(params) {
            return request.multipartPost(`v1/admin/channel/xlsx`, {}, params.file).then(({data}) => data);
        },

        createFastLive(params) {
            return request.javaPost('v1/admin/channel/contents', params).then(({data}) => data);
        },
        updateFastLive(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx;
            return request.javaPut(`v1/admin/channel/contents/${fcIdx}`, params).then(({data}) => data);
        },
        deleteFastLive(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx;
            return request.javaDelete(`v1/admin/channel/contents/${fcIdx}`, params).then(({data}) => data);
        },
        startFastLive(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx
            return request.javaPost(`v1/admin/channel/contents/${fcIdx}/start`, params).then(({data}) => data);
        },
        stopFastLive(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx
            return request.javaPost(`v1/admin/channel/contents/${fcIdx}/stop`, params).then(({data}) => data);
        },
        getFastLiveContent(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx
            return request.javaGet(`v1/admin/channel/contents/${fcIdx}/schedule`, params).then(({data}) => data);
        },
        setFastSchedule(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx
            return request.javaPost(`v1/admin/channel/contents/program/${fcIdx}`, params).then(({data}) => data);
        },
        setFastScheduleRetry(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx
            return request.javaPost(`v1/admin/channel/contents/program/${fcIdx}/retry`, params).then(({data}) => data);
        },
        getFastAdvertSchedule(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx
            return request.javaGet(`v1/admin/channel/contents/${fcIdx}/ad/setting`, params).then(({data}) => data);
        },
        getContentLiveAdSchedule(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx
            return request.javaGet(`v1/admin/channel/contents/${fcIdx}/ad/setting`, params).then(({data}) => data);
        },
        setFastAdvertSchedule(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx
            return request.javaPost(`v1/admin/channel/contents/ad/${fcIdx}`, params).then(({data}) => data);
        },
        setFastAdvertScheduleRetry(params) {
            let fcIdx = params.fcIdx;
            delete params.fcIdx
            return request.javaPost(`v1/admin/channel/contents/ad/${fcIdx}/retry`, params).then(({data}) => data);
        },
        createPaidChannelBundle(params) {
            return request.javaPost(`v1/admin/channel/bundle`, params).then(({data}) => data);
        },
        updatePaidChannelBundle(params) {
            let cbIdx = params.cbIdx;
            delete params.cbIdx
            return request.javaPut(`v1/admin/channel/bundle/${cbIdx}`, params).then(({data}) => data);
        },
        deletePaidChannelBundle(params) {
            let cbIdx = params.cbIdx;
            delete params.cbIdx
            return request.javaDelete(`v1/admin/channel/bundle/${cbIdx}`, params).then(({data}) => data);
        },
        startLive(params) {
            let caIdx = params.caIdx;
            delete params.caIdx
            return request.javaPost(`v1/admin/channel/${caIdx}/start`, params).then(({data}) => data);
        },
        stopLive(params) {
            let caIdx = params.caIdx;
            delete params.caIdx
            return request.javaPost(`v1/admin/channel/${caIdx}/stop`, params).then(({data}) => data);
        },
        getLiveUserView(params) {
            return request.javaGet('v1/public/channel/setting', params).then(({data}) => data);
        },
        getChannelDisplay(params) {
            return request.javaGet('v1/admin/channel/display', params).then(({data}) => data);
        },
        updateChannelDisplay(params) {
            let lcdiIdx = params.lcdiIdx;
            delete params.lcdiIdx;
            return request.javaPut(`v1/admin/channel/display/${lcdiIdx}`, params).then(({data}) => data);
        },
        updateLiveUserView(params) {
            let csIdx = params.csIdx;
            delete params.csIdx
            return request.javaPut(`v1/admin/channel/order/${csIdx}`, params).then(({data}) => data);
        },
        updateLiveBlackOut(params) {
            return request.javaPatch('v1/admin/channel/blackout', params).then(({data}) => data);
        },
        getLiveGenre(params) {
            return request.javaGet(`v1/admin/channel/genre/admin`, params).then(({data}) => data);
        },
        createLiveGenre(params) {
            return request.javaPost(`v1/admin/channel/genre`, params).then(({data}) => data);
        },
        updateLiveGenre(params) {
            let cgIdx = params.cgIdx;
            delete params.cgIdx
            return request.javaPut(`v1/admin/channel/genre/${cgIdx}`, params).then(({data}) => data);
        },
        deleteLiveGenre(params) {
            let cgIdx = params.cgIdx;
            delete params.cgIdx
            return request.javaDelete(`v1/admin/channel/genre/${cgIdx}`, params).then(({data}) => data);
        },
        getCityLiveCategory(params) {
            return request.javaGet(`v1/admin/channel/city/channel/category/admin`, params).then(({data}) => data);
        },
        updateCityLiveCategory(params) {
            let cccIdx = params.cccIdx;
            delete params.cccIdx
            return request.javaPut(`v1/admin/city/channel/genre/${cccIdx}`, params).then(({data}) => data);
        },
        createCityLiveCategory(params) {
            return request.javaPost(`v1/admin/city/channel/genre`, params).then(({data}) => data);
        },
        deleteCityLiveCategory(params) {
            let cccIdx = params.cccIdx;
            delete params.cccIdx
            return request.javaDelete(`v1/admin/city/channel/genre/${cccIdx}`, params).then(({data}) => data);
        },
        getCityLive(params) {
            return request.javaGet(`v1/admin/channel/city`, params).then(({data}) => data);
        },
        getCityLiveDetail(params) {
            let ccIdx = params.ccIdx;
            delete params.ccIdx
            return request.javaGet(`v1/admin/channel/city/${ccIdx}/detail`, params).then(({data}) => data);
        },
        createCityLive(params) {
            return request.javaPost(`v1/admin/city/channel`, params).then(({data}) => data);
        },
        deleteCityLive(params) {
            let ccIdx = params.ccIdx;
            delete params.ccIdx
            return request.javaDelete(`v1/admin/city/channel/${ccIdx}`, params).then(({data}) => data);
        },
        startCityLive(params) {
            let ccIdx = params.ccIdx;
            delete params.ccIdx
            return request.javaPost(`v1/admin/city/channel/${ccIdx}/start`, params).then(({data}) => data);
        },
        stopCityLive(params) {
            let ccIdx = params.ccIdx;
            delete params.ccIdx
            return request.javaPost(`v1/admin/city/channel/${ccIdx}/stop`, params).then(({data}) => data);
        },
        getCityLiveContent(params) {
            let ccIdx = params.ccIdx;
            delete params.ccIdx
            return request.javaGet(`v1/admin/channel/city/${ccIdx}/programs`, params).then(({data}) => data);
        },
        getCityAdvertSchedule(params) {
            let ccIdx = params.ccIdx;
            delete params.ccIdx;
            return request.javaGet(`v1/admin/channel/city/${ccIdx}/ads`, params).then(({data}) => data);
        },
        setCitySchedule(params) {
            let ccIdx = params.ccIdx;
            delete params.ccIdx;
            return request.javaPost(`v1/admin/city/channel/program/${ccIdx}`, params).then(({data}) => data);
        },
        setCityScheduleRetry(params) {
            let ccIdx = params.ccIdx;
            delete params.ccIdx;
            return request.javaPost(`v1/admin/city/channel/program/${ccIdx}/retry`, params).then(({data}) => data);
        },
        setCityAdvertSchedule(params) {
            let ccIdx = params.ccIdx;
            delete params.ccIdx;
            return request.javaPost(`v1/admin/city/channel/ad/${ccIdx}`, params).then(({data}) => data);
        },
        setCityAdvertScheduleRetry(params) {
            let ccIdx = params.ccIdx;
            delete params.ccIdx;
            return request.javaPost(`v1/admin/city/channel/ad/${ccIdx}/retry`, params).then(({data}) => data);
        },
        updateCityLive(params) {
            let ccIdx = params.ccIdx;
            delete params.ccIdx;
            return request.javaPut(`v1/admin/city/channel/${ccIdx}`, params).then(({data}) => data);
        },


        //TODO수정예정
        getContentsListingDetail(params){
            let key = params.key;
            delete params.key;
            return request.javaGet(`v1/admin/fast/channel/link/${key}`, params).then(({data}) => data);
        },
        getCityListingDetail(params){
            let key = params.key;
            delete params.key;
            return request.javaGet(`v1/admin/city/channel/link/${key}`, params).then(({data}) => data);
        },
        createContentsListing(params){
            return request.javaPost(`v1/admin/fast/channel/link`, params).then(({data}) => data);
        },
        createCityListing(params){
            return request.javaPost(`v1/admin/city/channel/link`, params).then(({data}) => data);
        },

        updateContentsListing(params){
            return request.javaPut(`v1/admin/fast/channel/link`, params).then(({data}) => data);
        },
        updateCityListing(params){
            return request.javaPut(`v1/admin/city/channel/link`, params).then(({data}) => data);
        },
        deleteContentsListing(params){
            let key = params.key;
            delete params.key;
            return request.javaDelete(`v1/admin/fast/channel/link/${key}`, params).then(({data}) => data);
        },

        deleteCityListing(params){
            let key = params.key;
            delete params.key;
            return request.javaDelete(`v1/admin/city/channel/link/${key}`, params).then(({data}) => data);
        },
    },
    $database: {
        getDownloadHistory(params) {
            return request.javaGet("v1/admin/download/history", params).then(({data}) => data);
        },
        createDownloadHistory(params) {
            return request.javaPost("v1/admin/download/history", params).then(({data}) => data);
        },
        getRequest(params) {
            return request.javaGet(`v1/admin/download/request/all`, params).then(({data}) => data);
        },
        getRequestApproved(params) {
            return request.javaGet(`v1/admin/download/approve/all`, params).then(({data}) => data);
        },
        getRequestApprovedDetail(params) {
            let drIdx = params.drIdx;
            delete params.drIdx;
            return request.javaGet(`v1/admin/download/approve/detail/${drIdx}`, params).then(({data}) => data);
        },

        getRequestNormal(params) {
            return request.javaGet(`v1/admin/download/request`, params).then(({data}) => data);
        },

        getDownloadRequestDetail(params) {
            let drIdx = params.drIdx;
            delete params.drIdx;
            return request.javaGet(`v1/admin/download/request/detail/${drIdx}`, params).then(({data}) => data);
        },
        createDatabase(params) {
            return request.javaPost("v1/admin/download/request", params).then(({data}) => data);
        },
        deleteDatabase(params) {
            let drIdx = params.drIdx;
            delete params.drIdx;
            return request.javaDelete(`v1/admin/download/request/${drIdx}`, params).then(({data}) => data);
        },
        updateDatabase(params) {
            return request.javaPut("admin/download/request", params).then(({data}) => data);
        },
        updateDatabaseStatus(params) {
            return request.javaPut("v1/admin/download/request/status", params).then(({data}) => data);
        },
        addCountDatabase(params) {
            let drIdx = params.drIdx;
            delete params.drIdx;
            return request.javaPut(`v1/api/download/request/${drIdx}`, params).then(({data}) => data);
        },

    },
    $log: {
        getLog(params) {
            return request.javaGet("v1/admin/cms/log", params).then(({data}) => data);
        },
        createLog(params) {
            return request.javaPost("v1/admin/cms/log", params).then(({data}) => data);
        }
    },
    $item: {
        getItem(params) {
            return request.javaGet("v1/admin/item", params).then(({data}) => data);
        },
        getItemAdvertise(params) {
            return request.javaGet("v1/admin/advertise/products", params).then(({data}) => data);
        },
        getItemAdvertiseDetail(params) {
            let key = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/advertise/products/${key}`, params).then(({data}) => data);
        },
        createItem(params) {
            return request.javaPost('v1/admin/item', params).then(({data}) => data);
        },
        updateItem(params) {
            let itIdx = params.itIdx;
            delete params.itIdx;
            return request.javaPut(`v1/admin/item/${itIdx}`, params).then(({data}) => data);
        },

        getItemVod(params) {
            return request.javaGet("v1/admin/item/vod", params).then(({data}) => data);
        },
        getItemVodDetail(params) {
            let itIdx = params.itIdx;
            delete params.itIdx;
            return request.javaGet(`v1/admin/item/vod/${itIdx}`, params).then(({data}) => data);
        },

        deleteItemVod(params) {
            let itIdx = params.itIdx;
            delete params.itIdx;
            return request.javaDelete(`v1/admin/item/vod/${itIdx}`, params).then(({data}) => data);
        },

        getInstructionInfo(params) {
            let inType = params.inType;
            delete params.inType;
            return request.javaGet(`v1/admin/item/instruction/${inType}`, params).then(({data}) => data);
        },
        updateInstruction(params) {
            let inType = params.inType;
            delete params.inType;
            let inIdx = params.inIdx;
            delete params.inIdx;
            return request.javaPatch(`v1/admin/item/instruction/${inType}/${inIdx}`, params).then(({data}) => data);
        },
    },
    $payment: {
        cancelHalfPayment(params) {
            return request.javaDelete('v1/admin/order/cancel/partial', params).then(({data}) => data);
        },
    },
    $campaign: {
        getUsableSegment(params) {
            return request.getJavaStatistics("v1/segments/usable", params).then(({data}) => data);
        },
    },
    $policy: {


        getPointPolicyDetail(params) {
            return request.javaGet('v1/admin/point/policy/daily', params).then(({data}) => data);
        },
        getContinuousAttendancePolicy(params) {
            return request.javaGet('v1/admin/point/policy/Attendance', params).then(({data}) => data);
        },
        getDailyMissionPolicy(params) {
            return request.javaGet('v1/admin/point/policy/daily', params).then(({data}) => data);
        },
        getPointExtraPolicy(params) {
            return request.javaGet('v1/admin/point/policy/etc', params).then(({data}) => data);
        },
        getMediaPointPolicy(params) {
            return request.javaGet('v1/admin/point/policy/media', params).then(({data}) => data);
        },
        getPayPolicy(params) {
            return request.javaGet('v1/admin/point/policy/pay', params).then(({data}) => data);
        },
        getPointDefine(params) {
            return request.javaGet('v1/admin/mission/define', params).then(({data}) => data);
        },
        createPointPolicy(params) {
            return request.javaPost('v1/point/mission', params).then(({data}) => data);
        },
        updatePointPolicy(params) {
            let pdIdx = params.pdIdx;
            delete params.pdIdx;
            return request.javaPut(`v1/point/mission/${pdIdx}`, params).then(({data}) => data);
        },
        updateAttendancePointPolicy(params) {
            let pdIdx = params.pdIdx;
            delete params.pdIdx;
            return request.javaPut(`v1/point/mission/sequence-attendance/${pdIdx}`, params).then(({data}) => data);
        },
        getPointRoulettePolicy(params) {
            return request.javaGet('v1/admin/point/policy/roulette', params).then(({data}) => data);
        },
        updatePointRoulettePolicy(params) {
            return request.javaPut('v1/point/mission/roulette', params).then(({data}) => data);
        },
        getEvent(params) {
            return request.javaGet('v1/admin/event-tap', params).then(({data}) => data);
        },
        getEventMgmt(params) {
            return request.javaGet('v1/admin/event', params).then(({data}) => data);
        },
        getGiftEvent(params) {
            return request.javaGet('v1/admin/event/gift-box', params).then(({data}) => data);
        },
        getEventMgmtDetail(params){
            let evIdx = params.evIdx;
            delete params.evIdx;
            return request.javaGet(`v1/admin/event/${evIdx}`, params).then(({data}) => data);
        },
        createEventMgmt(params) {
            return request.javaPost('v1/admin/event', params).then(({data}) => data);
        },
        updateEventMgmt(params) {
            let evIdx = params.evIdx;
            delete params.evIdx;
            return request.javaPut(`v1/admin/event/${evIdx}`, params).then(({data}) => data);
        },
        deleteEventMgmt(params) {
            return request.javaDelete('v1/admin/event', params).then(({data}) => data);
        },
        endEventMgmt(params) {
            let evIdx = params.evIdx;
            delete params.evIdx;
            return request.javaPatch(`v1/admin/event/${evIdx}/end`, params).then(({data}) => data);
        },
        getEventGiftHistory(params) {
            let evIdx = params.evIdx;
            delete params.evIdx;
            return request.javaGet(`v1/admin/event/${evIdx}/gift-box/issue`, params).then(({data}) => data);
        },
        getEventGiftHistoryExcel(params) {
            let evIdx = params.evIdx;
            delete params.evIdx;
            return request.javaGet(`v1/admin/event/${evIdx}/gift-box/issue/xlsx`, params).then(({data}) => data);
        },
        getGiftBoxMgmt(params) {
            return request.javaGet('v1/admin/gift-box', params).then(({data}) => data);
        },
        getGiftBoxHistory(params) {
            return request.javaGet('v1/admin/gift-box/history', params).then(({data}) => data);
        },
        /** 파트너(mbNo)별 선물상자 목록 — memberIdx는 mbNo와 동일 */
        getGiftBoxMemberList(params) {
            const memberIdx = params.mbNo ?? params.memberIdx;
            const query = { ...params };
            delete query.mbNo;
            delete query.memberIdx;
            return request.javaGet(`v1/admin/gift-box/member/${memberIdx}`, query).then(({data}) => data);
        },
        getGiftBoxIssueSegment(params) {
            let idx = params.idx;
            delete params.idx;
            return request.javaGet(`v1/admin/gift-box/issue/segment/${idx}`, params).then(({data}) => data);
        },
        uploadIssueExcel(params) {
            const files = Array.isArray(params.file)
                ? params.file.map((file) => file.raw !== undefined ? file : {raw: file})
                : [{raw: params.file}];
            return request.multipartPost('v1/excel/issue', {}, files).then(({data}) => data);
        },
        getGiftBoxMgmtDetail(params) {
            let gbIdx = params.gbIdx;
            delete params.gbIdx;
            return request.javaGet(`v1/admin/gift-box/${gbIdx}`, params).then(({data}) => data);
        },
        getGiftBoxIssueList(params) {
            let gbIdx = params.gbIdx;
            delete params.gbIdx;
            return request.javaGet(`v1/admin/gift-box/${gbIdx}/issue`, params).then(({data}) => data);
        },
        getGiftBoxIssueExcel(params) {
            let gbIdx = params.gbIdx;
            delete params.gbIdx;
            return request.javaGet(`v1/admin/gift-box/${gbIdx}/issue/xlsx`, params).then(({data}) => data);
        },
        createGiftBoxMgmt(params) {
            return request.javaPost('v1/admin/gift-box', params).then(({data}) => data);
        },
        updateGiftBoxMgmt(params) {
            let gbIdx = params.gbIdx;
            delete params.gbIdx;
            return request.javaPut(`v1/admin/gift-box/${gbIdx}`, params).then(({data}) => data);
        },
        deleteGiftBoxMgmt(params) {
            let gbIdx = params.gbIdx;
            delete params.gbIdx;
            return request.javaDelete(`v1/admin/gift-box/${gbIdx}`, params).then(({data}) => data);
        },
        recallGiftBoxMgmt(params) {
            let gbIdx = params.gbIdx;
            delete params.gbIdx;
            return request.javaPatch(`v1/admin/gift-box/${gbIdx}/recall`, params).then(({data}) => data);
        },
        updateEvent(params) {
            let etIdx = params.etIdx;
            delete params.etIdx;
            return request.javaPut(`v1/admin/event-tap/${etIdx}`, params).then(({data}) => data);
        },
    },
    $content: {
        getHomeMedia(params) {
            return request.javaGet('v1/admin/home/display', params).then(({data}) => data);
        },

        //TODO
        // getHomeMedia(params) {
        //     return request.get('home/display', params).then(({data}) => data);
        // },
        createHomeMedia(params) {
            return request.javaPost('v1/admin/home/display', params).then(({data}) => data);
        },
        updateHomeMedia(params) {
            return request.javaPut('v1/admin/home/display', params).then(({data}) => data);
        },
        deleteHomeMedia(params) {
            let hdIdx = params.hdIdx;
            delete params.hdIdx;
            return request.javaDelete(`v1/admin/home/display/${hdIdx}`, params).then(({data}) => data);
        },
        getContentProvider(params) {
            return request.javaGet('v1/admin/content/provider', params).then(({data}) => data);
        },
        createContentProvider(params) {
            return request.javaPost(`v1/admin/content/provider`, params).then(({data}) => data);
        },
        getContentProviderInfo(params) {
            let id = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/content/provider/${id}`, params).then(({data}) => data);
        },
        updateContentProvider(params) {
            let cpIdx = params.cpIdx;
            delete params.cpIdx;
            return request.javaPut(`v1/admin/content/provider/${cpIdx}`, params).then(({data}) => data);
        },
        deleteContentProvider(params) {
            let cpIdx = params.cpIdx;
            delete params.cpIdx;
            return request.javaDelete(`v1/admin/content/provider/${cpIdx}`, params).then(({data}) => data);
        },
        getContentProviderOption(params) {
            return request.javaGet(`v1/admin/content/provider/simple`, params).then(({data}) => data);
        },
    },
    $statisticsin: {
        getVod(params) {
            return request.getJavaStatistics(`v1/admin/media/statistics`, params).then(({data}) => data);
        },
    },
    $comment: {
        getComment(params) {
            let meIdx = params.meIdx;
            delete params.meIdx;
            return request.javaGet(`v1/admin/media/comment/list/${meIdx}`, params).then(({data}) => data);
        },
        getCommentBoard(params) {
            return request.javaGet(`v1/admin/partner/board/comment`, params).then(({data}) => data);
        },
        getCommentMedia(params) {
            return request.javaGet(`v1/admin/media/comment/list`, params).then(({data}) => data);
        },
        getCommentDetail(params) {
            let id = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/media/comment/${id}`, params).then(({data}) => data);
        },
        deleteComment(params) {
            let mcoIdx = params.mcoIdx;
            delete params.mcoIdx;
            return request.javaDelete(`v1/admin/media-comment/${mcoIdx}`, params).then(({data}) => data);
        },

    },

    $zone: {
        getZone(params) {
            return request.javaGet('v1/admin/partner/board/zone/manage', params).then(({data}) => data);
        },
        getZoneDetail(params) {
            let id = params.id;
            delete params.id;
            return request.javaGet(`v1/admin/partner/board/member-partner/board/detail/${id}`, params).then(({data}) => data);
        },
        getZonePartnerDetail(params) {
            return request.javaGet(`v1/admin/partner/board/member-partner/board`, params).then(({data}) => data);
        },
        deletePartnerBoard(params) {
            let id = params.id;
            delete params.id;
            return request.javaDelete(`v1/admin/partner/board/post/${id}`, params).then(({data}) => data);
        },
        deletePartnerBoardComment(params) {
            let id = params.id;
            delete params.id;
            return request.javaDelete(`v1/admin/partner/board/comment/${id}`, params).then(({data}) => data);
        },
        deletePartnerMediaComment(params) {
            let id = params.id;
            delete params.id;
            return request.javaDelete(`v1/admin/media-comment/${id}`, params).then(({data}) => data);
        },
        getZoneComment(params) {
            let pbParent = params.pbParent;
            delete params.pbParent;
            return request.javaGet(`v1/admin/partner/board/comment/${pbParent}`, params).then(({data}) => data);
        },
        getZoneCommentDetail(params) {
            return request.javaGet('v1/admin/partner/board/comment/detail', params).then(({data}) => data);
        },
    },
    $forbidden: {
        getForbidden(params) {
            return request.javaGet('v1/admin/prohibit-word', params).then(({data}) => data);
        },
        updateForbidden(params) {
            let pwIdx = params.pwIdx;
            delete params.pwIdx;
            return request.javaPut(`v1/admin/prohibit-word/${pwIdx}`, params).then(({data}) => data);
        },
    },
    $rate: {
        getRate(params) {
            return request.javaGet(`v1/admin/point-rate`, params).then(({data}) => data);
        },
        getRateDetail(params) {
            let prIdx = params.prIdx;
            delete params.prIdx;
            return request.javaGet(`v1/admin/point/rate/${prIdx}`, params).then(({data}) => data);
        },
        createRate(params) {
            function toIsoUtc(dateStr) {
                return new Date(dateStr.replace(" ", "T") + "Z").toISOString();
            }

            // prStartDate / prEndDate 변환
            if (params.prStartDate) {
                params.prStartDate = toIsoUtc(params.prStartDate);
            }
            if (params.prEndDate) {
                params.prEndDate = toIsoUtc(params.prEndDate);
            }
            return request.javaPost('v1/admin/point-rate', params).then(({data}) => data);
        },
        updateRate(params) {
            let prIdx = params.prIdx;
            delete params.prIdx;

            function toIsoUtc(dateStr) {
                return new Date(dateStr.replace(" ", "T") + "Z").toISOString();
            }

            // prStartDate / prEndDate 변환
            if (params.prStartDate) {
                params.prStartDate = toIsoUtc(params.prStartDate);
            }
            if (params.prEndDate) {
                params.prEndDate = toIsoUtc(params.prEndDate);
            }
            return request.javaPut(`v1/admin/point-rate/${prIdx}`, params).then(({data}) => data);
        },
        deleteRate(params) {
            let prIdx = params.prIdx;
            delete params.prIdx;
            return request.javaDelete(`v1/admin/point-rate/${prIdx}`, params).then(({data}) => data);
        },
    },
    $subscript: {
        getSubscript(params) {
            return request.javaGet('v1/subscription/notice/admin', params).then(({data}) => data);
        },
        getSubscriptCategory(params) {
            return request.javaGet('v1/subscription/admin/notice/category', params).then(({data}) => data);
        },

        getSubscriptDetail(params) {
            let id = params.id;
            delete params.id;
            return request.javaGet(`v1/subscription/notice/${id}/admin`, params).then(({data}) => data);
        },
        createSubscript(params) {
            return request.javaPost('v1/subscription/notice/admin', params).then(({data}) => data);
        },
        updateSubscript(params) {
            let snIdx = params.snIdx;
            delete params.snIdx;
            return request.javaPut(`v1/subscription/notice/${snIdx}/admin`, params).then(({data}) => data);
        },

        deleteSubscript(params) {
            let snIdx = params.snIdx;
            delete params.snIdx;
            return request.javaDelete(`v1/subscription/notice/${snIdx}/admin`, params).then(({data}) => data);
        },

        endSubscript(params) {
            let snIdx = params.snIdx;
            delete params.snIdx;
            return request.javaPatch(`v1/subscription/notice/${snIdx}/admin/end`, params).then(({data}) => data);
        },
        getSubscriptConfirm(params) {
            return request.javaGet('v1/subscription/notice-confirm/list', params).then(({data}) => data);
        },

        getSo(params) {
            return request.javaGet('v1/so', params).then(({data}) => data);
        },


    },

    $recommend:{
        getRecommend(params) {
            return request.javaGet(`v1/admin/content/recommend/menu`, params).then(({data}) => data);
        },

        deleteRecommend(params) {
            return request.javaDelete('v1/admin/content/recommend/menu', params).then(({data}) => data);
        },

        createRecommend(params) {
            return request.javaPost('v1/admin/content/recommend/menu', params).then(({data}) => data);
        },
        updateRecommend(params) {
            let key = params.key;
            delete params.key;
            return request.javaPut(`v1/admin/content/recommend/menu/${key}`, params).then(({data}) => data);
        },
        updateRecommendSeq(params) {
            let key = params.key;
            delete params.key;
            let seq = params.seq;
            delete params.seq;
            return request.javaPatch(`v1/admin/content/recommend/menu/${key}/${seq}`, params).then(({data}) => data);
        },
        getRecommendDetail(params) {
            let key = params.key;
            delete params.key;
            return request.javaGet(`v2/admin/content/recommend/menu/${key}`, params).then(({data}) => data);
        },

        deleteRecommendDetail(params) {
            let key = params.key;
            delete params.key;
            return request.javaDelete(`v1/admin/content/recommend/menu/${key}`, params).then(({data}) => data);
        },

        getRecommendContents(params) {
            let crmIdx = params.crmIdx;
            delete params.crmIdx;
            return request.javaGet(`v1/admin/content/recommend/${crmIdx}`, params).then(({data}) => data);
        },


        createRecommendContents(params) {
            return request.javaPost('v1/admin/content/recommend', params).then(({data}) => data);
        },

        bulkCreateRecommendContents(params) {
            return request.javaPost('v2/admin/content/recommend', params).then(({data}) => data);
        },

        updateRecommendContents(params) {
            let crIdx = params.crIdx;
            delete params.crIdx;
            let crSeq = params.crSeq;
            delete params.crSeq;
            return request.javaPatch(`v1/admin/content/recommend/${crIdx}/${crSeq}`, params).then(({data}) => data);
        },

        getAutoRecommendMediaList(params) {
            return request.javaGet('v1/admin/content/recommend/auto-modal', params).then(({data}) => data);
        },

    },
    $homeChoice:{
        updateHomeChoiceSetting(params) {
            return request.javaPut(`v1/admin/home-choice`, params).then(({data}) => data);
        },
        getHomeChoiceSetting(params) {
            return request.javaGet(`v1/admin/home-choice`, params).then(({data}) => data);
        },
    },
    $topten: {
        getToptenCategory(params) {
            let platform = params.platform;
            delete params.platform;
            return request.javaGet(`v1/admin/top10/${platform}/category`, params).then(({data}) => data);
        },
        getToptenCategoryDetail(params){
            let tcIdx = params.tcIdx;
            delete params.tcIdx;
            return request.javaGet(`v1/admin/top10/category/${tcIdx}`, params).then(({data}) => data);
        },
        updateToptenCategory(params) {
            let tcIdx = params.tcIdx;
            delete params.tcIdx;
            return request.javaPatch(`v1/admin/top10/category/${tcIdx}`, params).then(({data}) => data);
        },
        getToptenContent(params){
            let tcIdx = params.tcIdx;
            delete params.tcIdx;
            return request.javaGet(`v1/admin/top10/category/${tcIdx}/media`, params).then(({data}) => data);
        },
        editToptenContent(params) {
            return request.javaPost(`v1/admin/top10/category/media`, params).then(({data}) => data);
        },
    },
    $handler: {
        authHeader: setAuthInHeader
    }
};



export default $api;
